// @ts-nocheck
import moment from 'moment';
import { InclusionExclusionType } from '../components/Messages/Messages.types';

export const EVENT_RISK_STATUS = {
    NONE: 1,
    FREEZE: 2,
    UN_FREEZE: 3,
    CANCEL: 4,
    UNKNOWN: 0,
};

export const MBN_COLORS = {
    0: '#8e8e8e',
    1: '#096dd9',
    2: '#cab311',
    3: '#389e0d',
};

export const BREAKPOINTS = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1600,
};

export const PERMISSION_TYPES = {
    1: 'READ',
    2: 'EDIT',
    3: 'CREATE',
    4: 'DELETE',
};

export const PERMISSIONS = {
    create: 'CREATE',
    view: 'READ',
    update: 'EDIT',
    delete: 'DELETE',
};

export const dateFormat = 'DD/MM/YYYY';
export const newDateAndTimeFormat = 'DD/MM/YYYY, HH:mm';
export const logsDateAndTimeFormat = 'DD/MM/YYYY, HH:mm:ss';
export const newDateAndTimeFormatWithSeconds = 'DD/MM/YYYY, HH:mm:ss';

export const PAGINATION_SIZES = [20, 50, 100, 200];
export const MAX_PAGE_SIZE = 200;
export const LOGS_PAGINATION_SIZE = 25;
export const MESSAGES_PAGINATION_SIZE = 20;
export const REPORTS_PAGINATION_SIZE = 20;
export const COMBINATION_LOCK_PAGINATION_SIZE = 20;
export const BET_ACCEPTANCE_TIME_PAGINATION_SIZE = 50;
export const STATUS_IDS = {
    active: 1,
    inactive: 2,
    deleted: 3,
};

export const PAYMENT_OPTIONS = [
    {
        id: 'paid',
        name: 'Paid',
    },
    {
        id: 'unpaid',
        name: 'Unpaid',
    },
];

export const TICKET_TYPES = {
    single: 'SINGLE',
    combo: 'COMBO',
    system: 'SYSTEM',
    multiSingle: 'MULTI_SINGLE',
    multiSystem: 'MULTI_SYSTEM',
};

export const AMOUNT_TYPES = [
    {
        id: 0,
        name: 'Stake amount',
    },
    {
        id: 1,
        name: 'Return amount',
    },
    {
        id: 2,
        name: 'Win amount',
    },
    {
        id: 3,
        name: 'Free Bet Stake amount',
    },
];

export const TICKET_TYPES_ENUM = {
    single: 1,
    combo: 2,
    system: 3,
    multiSingle: 4,
    multiSystem: 5,
};

export const BET_TYPES_OPTIONS = [
    {
        id: TICKET_TYPES_ENUM.single,
        name: 'Single',
    },
    {
        id: TICKET_TYPES_ENUM.combo,
        name: 'Combo',
    },
    {
        id: TICKET_TYPES_ENUM.system,
        name: 'System',
    },
    {
        id: TICKET_TYPES_ENUM.multiSingle,
        name: 'Multi-Single',
    },
    {
        id: TICKET_TYPES_ENUM.multiSystem,
        name: 'Multi-System',
    },
];

export const BONUS_BET_TYPES_OPTIONS = [
    {
        value: 'SINGLE',
        label: 'Single',
    },
    {
        value: 'COMBO',
        label: 'Combo',
    },
];

export const TICKET_STATUSES = {
    0: 'Unknown',
    1: 'Open',
    2: 'Closed',
    3: 'Cancelled',
    4: 'Won',
    5: 'Lost',
    6: 'Draw',
    7: 'Void',
    8: 'Half Lost',
    9: 'Half Won',
    10: 'Refunded',
    12: 'Paid',
    13: 'Cash Out',
};

export const OUTCOME_STATUSES = {
    0: 'Open',
    1: 'Closed',
    2: 'Won',
    3: 'Lost',
    4: 'Cancelled',
};

export const BETLINE_SETTLEMENT_STATUSES = [
    { id: 1, option: 'Open' },
    { id: 10, option: 'Refund' },
    { id: 4, option: 'Won' },
    { id: 5, option: 'Lost' },
];

export const BETS_HISTORY_DATE_TYPES = [
    {
        id: 'CREATION_TIME',
        name: 'Bet Placement Date',
    },
    {
        id: 'SETTLEMENT_TIME',
        name: 'Bet Settlement Date',
    },
];

export const DEPOSIT_WITHDRAWALS_DATE_TYPES = [
    {
        id: 'CREATION',
        name: 'Creation Date',
    },
    {
        id: 'UPDATE',
        name: 'Last Update Date',
    },
];

export const SELECTION_COUNTS = [
    { id: 1, label: '1' },
    { id: 2, label: '2' },
    { id: 3, label: '3' },
    { id: 4, label: '4' },
    { id: 5, label: '5' },
    { id: 6, label: '6' },
    { id: 7, label: '7' },
    { id: 8, label: '8' },
    { id: 9, label: '9' },
    { id: 10, label: '10' },
    { id: 11, label: '11' },
    { id: 12, label: '12' },
    { id: 13, label: '13' },
    { id: 14, label: '14' },
    { id: 15, label: '15' },
    { id: 16, label: '16' },
    { id: 17, label: '17' },
    { id: 18, label: '18' },
    { id: 19, label: '19' },
    { id: 20, label: '20' },
];

export const BET_ACCEPTANCE_SELECTION_COUNTS = [
    { id: 0, label: 'All' },
    { id: 1, label: '1' },
    { id: 2, label: '2' },
    { id: 3, label: '3' },
    { id: 4, label: '4' },
    { id: 5, label: '5' },
    { id: 6, label: '6+' },
];

export const LOG_SERVICE_NAMES = {
    city: 'CITY',
    status: 'STATUS',
    region: 'REGION',
    ticket: 'TICKET',
    user: 'USER',
    sportWeight: 'SPORT',
    categoryWeight: 'CATEGORY',
    leagueWeight: 'LEAGUE',
    email: 'EMAIL',
    emailGroup: 'EMAIL_GROUP',
    eventMonitoring: 'EVENT_MONITORING',
    userInterfaceRetail: 'CONTENT_TRANSLATION',
    serverErrors: 'CONTENT_ERROR',
    selfExclusion: 'SELF_EXCLUDE_UPDATE',
    kycDocumentOperationStatus: 'KYC_DOCUMENT_UPDATE_OR_SAVE',
    playerDetailsUpdate: 'PLAYER_DETAILS_UPDATE',
};

export const LOGS_OPERATION_NAMES = {
    betAcceptanceTime: 'BET_ACCEPTANCE_TIME',
    marketGroup: 'MARKET_GROUP',
    marketTemplates: 'MARKET_TEMPLATES',
    marketResultTypes: 'MARKET_RESULT_TYPES',
    tournamentMbn: 'TOURNAMENT_MBN',
    manualSettlementByLine: 'MANUAL_SETTLEMENT_BY_LINE',
    combinationLock: 'COMBINATION_LOCK',
    paymentBlockUnblock: 'PAYMENT_BLOCK_UNBLOCK',
    selfExcludeUpdate: 'SELF_EXCLUDE_UPDATE',
    playerDetailsUpdate: 'PLAYER_DETAILS_UPDATE',
    cashoutBlockLeaguesAndMarkets: 'CASHOUT_BLOCK_AND_UNBLOCK_TEMPLATE_LEAGUE_AND_MARKET',
    cashoutBlockEvents: 'CASHOUT_BLOCK_AND_UNBLOCK_TEMPLATE_EVENT',
    cashoutBlockTicket: 'CASHOUT_BLOCK_AND_UNBLOCK_TEMPLATE_TICKET',
};

export const OPERATOR_FIELDS = {
    address: 'Headquarter Address',
    createdDate: 'Created Date',
    email: 'Email',
    fax: 'Fax',
    id: 'Id',
    maxStakeAmount: ' Max Stake',
    maxStakeAmountForESport: 'Max Stake (E-Sport)',
    minStakeAmount: 'Min Stake',
    minStakeAmountForESport: 'Min Stake (E-Sport)',
    name: 'Name',
    onlinePlayers: 'Online Players',
    operatorType: 'operator Type',
    payoutLimit: 'Payout Limit',
    phone: 'Phone Number',
    status: 'Status',
    taxes: 'Taxes',
    ticketExpPeriod: 'Ticket Expiration Period Value',
    ticketExpPeriodType: 'Ticket Expiration Period',
    taxValue: 'Winning Tax Percentage',
    taxStatus: 'Winning Tax Status',
    website: 'Website Address',
    winningTax: 'Winning Tax',
};

export const ACCOUNTING_REPORT_COLUMNS = {
    customerId: {
        key: 'customerId',
        label: 'Customer ID',
    },
    userName: {
        key: 'userName',
        label: 'Username',
    },
    fullName: {
        key: 'fullName',
        label: 'Full Name',
    },
    operator: {
        key: 'operator',
        label: 'Operator',
    },
    brand: {
        key: 'brand',
        label: 'Brand',
    },
    totalStake: {
        key: 'totalStake',
        label: 'Total Stake',
    },
    totalGain: {
        key: 'totalGain',
        label: 'Total Gain',
    },
    companyProfit: {
        key: 'companyProfit',
        label: 'Company Profit',
    },
    balanceAfter: {
        key: 'balanceAfter',
        label: 'Balance After',
    },
    paymentMethod: {
        key: 'paymentMethod',
        label: 'Payment Method',
    },
    wallet: {
        key: 'wallet',
        label: 'Wallet',
    },
    walletId: {
        key: 'walletId',
        label: 'WalletId',
    },
};

export const SPORT_WEIGHT_FIELDS = {
    id: 'Id',
    weight: 'Weight',
    sportName: 'Sport',
};

export const CATEGORY_WEIGHT_FIELDS = {
    id: 'Id',
    weight: 'Weight',
    sportName: 'Sport',
    categoryName: 'Category',
};

export const LEAGUE_WEIGHT_FIELDS = {
    id: 'Id',
    weight: 'Weight',
    sportName: 'Sport',
    categoryName: 'Category',
    leagueName: 'League',
};

export const EVENT_MONITORING_FIELDS = {
    preMatchActive: 'Pre-match blocked',
    liveActive: 'Live blocked',
};

export const USER_INTERFACE_RETAIL_FIELDS = {
    appType: 'App',
    key: 'Key',
    page: 'Page',
    eng: 'Translation - Eng',
    aze: 'Translation - Aze',
};

export const BETS_HISTORY_TICKET_TABLE_COLUMNS = {
    live: {
        key: 'live',
        label: 'Live',
    },
    id: {
        key: 'id',
        label: 'Bet ID',
    },
    code: {
        key: 'code',
        label: 'Ticket Code',
    },
    creationTime: {
        key: 'creationTime',
        label: 'Bet Placement',
    },
    agentId: {
        key: 'agentId',
        label: 'Cashier',
    },
    betType: {
        key: 'betType',
        label: 'Bet Type',
    },
    selections: {
        key: 'selections',
        label: 'Selections',
    },
    totalStakeAmount: {
        key: 'totalStakeAmount',
        label: 'Total Stake',
    },
    freeBetAmount: {
        key: 'freeBetAmount',
        label: 'Free Bet',
    },
    totalWinAmount: {
        key: 'totalWinAmount',
        label: 'Total Win',
    },
    totalPayAmount: {
        key: 'totalPayAmount',
        label: 'Total Pay',
    },
    totalBonusAmount: {
        key: 'totalBonusAmount',
        label: 'Total Bonus Amount',
    },
    ticketBonusUsage: {
        key: 'ticketBonusUsage',
        label: 'Ticket Bonus Usage',
    },
    finalWinAmount: {
        key: 'finalWinAmount',
        label: 'Final Win',
    },
    finalPayAmount: {
        key: 'finalPayAmount',
        label: 'Final Pay',
    },
    finalBonusAmount: {
        key: 'finalBonusAmount',
        label: 'Final Bonus Amount',
    },
    ticketSubStatus: {
        key: 'ticketSubStatus',
        label: 'Ticket Status',
    },
    paidAmount: {
        key: 'paidAmount',
        label: 'Paid Amount',
    },
    paymentTime: {
        key: 'paymentTime',
        label: 'Paid Date',
    },
    cancellationTime: {
        key: 'cancellationTime',
        label: 'Cancellation Date',
    },
    settlementTime: {
        key: 'settlementTime',
        label: 'Settlement Date',
    },
    expirationTime: {
        key: 'expirationTime',
        label: 'Expiration Date',
    },
    manuallySettled: {
        key: 'manuallySettled',
        label: 'Manually Settled',
    },
    paymentBlock: {
        key: 'paymentBlock',
        label: 'Payment Block',
    },
    winTax: {
        key: 'winTax',
        label: 'Win Tax%',
    },
    finalWinTaxAmount: {
        key: 'finalWinTaxAmount',
        label: 'Final Win Tax Amount',
    },
    bonusType: {
        key: 'bonusType',
        label: 'Bonus Type',
    },
    requestedTime: {
        key: 'requestedTime',
        label: 'Bet Request Date',
    },
    segmentName: {
        key: 'segmentName',
        label: 'Segment Name',
    },
    totalOdds: {
        key: 'totalOdds',
        label: 'Total Odds',
    },
};

export const BETS_HISTORY_BETLINES_TABLE_COLUMNS = {
    live: {
        key: 'live',
        label: 'Live',
    },
    scheduleTime: {
        key: 'scheduleTime',
        label: 'Event Date',
    },
    sportTypeName: {
        key: 'sportTypeName',
        label: 'Sport',
    },
    categoryName: {
        key: 'categoryName',
        label: 'Category',
    },
    longTermEventName: {
        key: 'longTermEventName',
        label: 'League',
    },
    eventName: {
        key: 'eventName',
        label: 'Event Name',
    },
    marketName: {
        key: 'marketName',
        label: 'Market Name',
    },
    bettingOdds: {
        key: 'bettingOdds',
        label: 'Odd',
    },
    outcomeName: {
        key: 'outcomeName',
        label: 'Outcome Name',
    },
    subStatus: {
        key: 'subStatus',
        label: 'Bet Status',
    },
    bancoEnabled: {
        key: 'bancoEnabled',
        label: 'Banco',
    },
    stakeAmount: {
        key: 'stakeAmount',
        label: 'Stake',
    },
};

export const QUICK_SEARCH_TICKET_COLUMNS = {
    live: {
        key: 'live',
        label: 'Live',
    },
    id: {
        key: 'id',
        label: 'Bet ID',
    },
    code: {
        key: 'code',
        label: 'Ticket Code',
    },
    creationTime: {
        key: 'creationTime',
        label: 'Bet Placement',
    },
    customerId: {
        key: 'customerId',
        label: 'Cashier',
    },
    betType: {
        key: 'betType',
        label: 'Bet Type',
    },
    bonusType: {
        key: 'bonusType',
        label: 'Bonus Type',
    },
    selections: {
        key: 'selections',
        label: 'Selections',
    },
    totalStakeAmount: {
        key: 'totalStakeAmount',
        label: 'Total Stake',
    },
    freeBetStakeAmount: {
        key: 'freeBetStakeAmount ',
        label: 'Free Bet',
    },
    totalWinAmount: {
        key: 'totalWinAmount',
        label: 'Total Win',
    },
    totalPayAmount: {
        key: 'totalPayAmount',
        label: 'Total Pay',
    },
    subStatus: {
        key: 'subStatus',
        label: 'Ticket Status',
    },
    requestedTime: {
        key: 'requestedTime',
        label: 'Bet Request Date',
    },
};

export const QUICK_SEARCH_BETLINES_COLUMNS = {
    live: {
        key: 'live',
        label: 'Live',
    },
    scheduleTime: {
        key: 'scheduleTime',
        label: 'Event Date',
    },
    sportTypeName: {
        key: 'sportTypeName',
        label: 'Sport',
    },
    categoryName: {
        key: 'categoryName',
        label: 'Category',
    },
    longTermEventName: {
        key: 'longTermEventName',
        label: 'League',
    },
    eventName: {
        key: 'eventName',
        label: 'Event Name',
    },
    marketName: {
        key: 'marketName',
        label: 'Market Name',
    },
    bettingOdds: {
        key: 'bettingOdds',
        label: 'Odd',
    },
    outcomeName: {
        key: 'outcomeName',
        label: 'Outcome Name',
    },
    subStatus: {
        key: 'subStatus',
        label: 'Bet Status',
    },
    bancoEnabled: {
        key: 'bancoEnabled',
        label: 'Banco',
    },
    stakeAmount: {
        key: 'stakeAmount',
        label: 'Stake',
    },
};

export const BETSMONITOR_TICKET_COLUMNS = {
    live: {
        key: 'live',
        label: 'Live',
    },
    id: {
        key: 'id',
        label: 'Bet ID',
    },
    code: {
        key: 'code',
        label: 'Ticket Code',
    },
    creationTime: {
        key: 'creationTime',
        label: 'Bet Placement',
    },
    agentId: {
        key: 'agentId',
        label: 'Cashier',
    },
    betType: {
        key: 'betType',
        label: 'Bet Type',
    },
    selections: {
        key: 'selections',
        label: 'Selections',
    },
    totalStakeAmount: {
        key: 'totalStakeAmount',
        label: 'Total Stake',
    },
    freeBetAmount: {
        key: 'freeBetAmount',
        label: 'Free Bet',
    },
    totalWinAmount: {
        key: 'totalWinAmount',
        label: 'Total Win',
    },
    totalPayAmount: {
        key: 'totalPayAmount',
        label: 'Total Pay',
    },
    finalPayAmount: {
        key: 'finalPayAmount',
        label: 'Final Pay',
    },
    totalOdds: {
        key: 'totalOdds',
        label: 'Total Odds',
    },
    ticketSubStatus: {
        key: 'ticketSubStatus',
        label: 'Ticket Status',
    },
    paymentBlock: {
        key: 'paymentBlock',
        label: 'Payment Block',
    },
    bonusType: {
        key: 'bonusType',
        label: 'Bonus Type',
    },
    requestedTime: {
        key: 'requestedTime',
        label: 'Bet Request Date',
    },
    segmentName: {
        key: 'segmentName',
        label: 'Segment Name',
    },
};
export const BETSMONITOR_BETLINES_COLUMNS = {
    live: {
        key: 'live',
        label: 'Live',
    },
    scheduleTime: {
        key: 'scheduleTime',
        label: 'Event Date',
    },
    sportTypeName: {
        key: 'sportTypeName',
        label: 'Sport',
    },
    categoryName: {
        key: 'categoryName',
        label: 'Category',
    },
    longTermEventName: {
        key: 'longTermEventName',
        label: 'League',
    },
    eventName: {
        key: 'eventName',
        label: 'Event Name',
    },
    marketName: {
        key: 'marketName',
        label: 'Market Name',
    },
    bettingOdds: {
        key: 'bettingOdds',
        label: 'Odd',
    },
    outcomeName: {
        key: 'outcomeName',
        label: 'Outcome Name',
    },
    subStatus: {
        key: 'subStatus',
        label: 'Bet Status',
    },
};

export const FEATURED_COLUMNS = {
    id: {
        key: 'id',
        label: 'Id',
    },
    sportTypeName: {
        key: 'sportTypeName',
        label: 'Sport',
    },
    categoryName: {
        key: 'categoryName',
        label: 'Category',
    },
    leagueName: {
        key: 'leagueName',
        label: 'League',
    },
    event: {
        key: 'event',
        label: 'Event',
    },
    startedAt: {
        key: 'startedAt',
        label: 'Started At',
    },
    isPopular: {
        key: 'isPopular',
        label: 'Is Popular',
    },
    weight: {
        key: 'weight',
        label: 'Weight',
    },
    action: {
        key: 'action',
        label: 'Action',
    },
};

export const MESSAGES_COLUMNS = {
    id: {
        key: 'id',
        label: 'ID',
    },
    sentBy: {
        key: 'sentBy',
        label: 'Sender',
    },
    sentAt: {
        key: 'sentAt',
        label: 'Date',
    },
    subject: {
        key: 'subject',
        label: 'Subject',
    },
    content: {
        key: 'content',
        label: 'Content',
    },
    sendAsNotification: {
        key: 'sendAsNotification',
        label: 'Send As Push Notification',
    },
    // accountNumbers: {
    //     key: 'accountNumbers',
    //     label: 'Account Numbers',
    // },
    // playerSegment: {
    //     key: 'playerSegment',
    //     label: 'Player Segment',
    // },
    // inclusionExclusionType: {
    //     key: 'inclusionExclusionType',
    //     label: 'Inclusion Exclusion Type',
    // },
    actions: {
        key: 'actions',
        label: 'Actions',
    },
};

export const MESSAGE_RECIPIENTS_COLUMNS = {
    id: {
        key: 'id',
        label: 'ID',
    },
    accountNumber: {
        key: 'accountNumber',
        label: 'Account Number',
    },
    status: {
        key: 'status',
        label: 'Status',
    },
    readAt: {
        key: 'readAt',
        label: 'Read At',
    },
};

export const USERS_COLUMNS = {
    id: {
        key: 'id',
        label: 'Id',
    },
    lastName: {
        key: 'lastName',
        label: 'Full Name',
    },
    username: {
        key: 'username',
        label: 'User Name',
    },
    email: {
        key: 'email',
        label: 'Email',
    },
    created: {
        key: 'created',
        label: 'Date Created',
    },
    statusId: {
        key: 'statusId',
        label: 'Status',
    },
    actions: {
        key: 'actions',
        label: 'Actions',
    },
};

export const SETTLEMENT_TICKETS_COLUMNS = {
    live: {
        key: 'live',
        label: 'Live',
    },
    id: {
        key: 'id',
        label: 'Bet ID',
    },
    code: {
        key: 'code',
        label: 'Ticket Code',
    },
    creationTime: {
        key: 'creationTime',
        label: 'Bet Placement',
    },
    agentId: {
        key: 'agentId',
        label: 'Cashier',
    },
    betType: {
        key: 'betType',
        label: 'Bet Type',
    },
    selections: {
        key: 'selections',
        label: 'Selections',
    },
    totalStakeAmount: {
        key: 'totalStakeAmount',
        label: 'Total Stake',
    },
    totalWinAmount: {
        key: 'totalWinAmount',
        label: 'Total Win',
    },
    totalPayAmount: {
        key: 'totalPayAmount',
        label: 'Total Pay',
    },
    ticketSubStatus: {
        key: 'ticketSubStatus',
        label: 'Ticket Status',
    },
    manuallySettled: {
        key: 'manuallySettled',
        label: 'Manually Settled',
    },
};

export const SETTLEMENT_BETLINES_COLUMNS = {
    live: {
        key: 'live',
        label: 'Live',
    },
    scheduleTime: {
        key: 'scheduleTime',
        label: 'Event Date',
    },
    sportTypeName: {
        key: 'sportTypeName',
        label: 'Sport',
    },
    categoryName: {
        key: 'categoryName',
        label: 'Category',
    },
    longTermEventName: {
        key: 'longTermEventName',
        label: 'League',
    },
    eventName: {
        key: 'eventName',
        label: 'Event Name',
    },
    marketName: {
        key: 'marketName',
        label: 'Market Name',
    },
    bettingOdds: {
        key: 'bettingOdds',
        label: 'Odd',
    },
    outcomeName: {
        key: 'outcomeName',
        label: 'Outcome Name',
    },
    subStatus: {
        key: 'subStatus',
        label: 'Bet Status',
    },
    settlementStatus: {
        key: 'settlementStatus',
        label: 'Settlement Status',
    },
    bancoEnabled: {
        key: 'bancoEnabled',
        label: 'Banco',
    },
    stakeAmount: {
        key: 'stakeAmount',
        label: 'Stake',
    },
};

export const COMBINATION_LOCK_BETLINES_TABLE_COLUMNS = {
    sportName: {
        key: 'sportName',
        label: 'Sport',
    },
    categoryName: {
        key: 'categoryName',
        label: 'Category',
    },
    leagueName: {
        key: 'leagueName',
        label: 'League',
    },
    eventName: {
        key: 'eventName',
        label: 'Event Name',
    },
    marketName: {
        key: 'marketName',
        label: 'Market',
    },
    outcomeName: {
        key: 'outcomeName',
        label: 'Outcome',
    },
    odd: {
        key: 'odd',
        label: 'AOdd',
    },
    producerType: {
        key: 'producerType',
        label: 'Competition Type',
    },
};

export const COMBINATION_LOCK_TABLE_COLUMNS = {
    lockDate: {
        key: 'lockDate',
        label: 'Lock/Unlock dates',
    },
    username: {
        key: 'username',
        label: 'User',
    },
    comment: {
        key: 'comment',
        label: 'Comment',
    },
    betLines: {
        key: 'betLines',
        label: 'Selections',
    },
    betType: {
        key: 'betType',
        label: 'Bet Type',
    },
    ticketId: {
        key: 'ticketId',
        label: 'Bet ID',
    },
    totalOdds: {
        key: 'totalOdds',
        label: 'Total Odds',
    },
    cashierCode: {
        key: 'cashierCode',
        label: 'Cashier Code',
    },
    id: {
        key: 'id',
        label: 'Actions',
    },
    channel: {
        key: 'channel',
        label: 'Channel',
    },
};

export const TICKET_CHANGE_TYPES = {
    UNKNOWN: 0,
    CREATED: 1,
    CANCELLED: 2,
    CANCELLED_MANUALLY: 3,
    TICKET_SETTLED: 4,
    BET_GROUP_SETTLED: 5,
    TICKET_PAYOUT: 6,
    TICKET_ROLLBACK_CANCEL: 7,
    TICKET_ROLLBACK_SETTLEMENT: 8,
    TICKET_CASH_OUT: 9,
};

export const SOCKET_UPDATE_TYPES = {
    eventUpdate: 'event-update',
    eventAdd: 'event-add',
    eventRemove: 'event-remove',
    marketUpdate: 'event-market-update',
    mainMarketUpdate: 'event-main-market-update',
    paymentCreate: 'CREATE',
    paymentUpdate: 'UPDATE',
};

export const SOCKET_CONTEXT_PAGES = {
    monitoringEvents: 'monitoring-events',
    monitoringMarkets: 'monitoring-markets',
    monitoringTickets: 'monitoring-tickets',
    monitoringDepositsWithdrawals: 'monitoring-deposits-withdrawals',
};

export const MINIMAL_ODD_VALUE = 1.01;

export const RISK_STATUSES = {
    2: {
        label: 'Frozen',
        color: 'blue',
    },
    4: {
        label: 'Cancelled',
        color: 'red',
    },
};

export const FILE_EXTENSIONS = {
    PDF: 'pdf',
    'MS:EXCEL': 'xlsx',
    HTML: 'html',
};

export const MARKET_STATUSES = {
    0: {
        name: 'Active',
        backgroundColor: 'green',
    },
    1: {
        name: 'Suspended',
        backgroundColor: 'orange',
    },
    2: {
        name: 'Deactivated',
        backgroundColor: 'red',
    },
    3: {
        name: 'Settled',
        backgroundColor: 'green',
    },
    4: {
        name: 'Cancelled',
        backgroundColor: 'red',
    },
    5: {
        name: 'Handed Over',
        backgroundColor: '',
    },
};

export const MARKET_STATUSES_ENUM = {
    active: 0,
    suspended: 1,
    deactivated: 2,
    settled: 3,
    cancelled: 4,
    handedOver: 5,
};

export const EVENT_STATUSES = {
    notStarted: 0,
    live: 1,
    suspended: 2,
    ended: 3,
    closed: 4,
    cancelled: 5,
    abandoned: 6,
    delayed: 7,
    unknown: 8,
    postponed: 9,
    interrupted: 10,
};

export const EDITABLE_STATUSES = [0, 1, 2];

export const dateRanges = {
    Today: () => [moment().startOf('day'), moment().endOf('day')],
    Yesterday: () => [moment().subtract(1, 'day').startOf('day'), moment().subtract(1, 'day').endOf('day')],
    'This Week': () => [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
    'Last Week': () => [
        moment().subtract(1, 'weeks').startOf('isoWeek'),
        moment().subtract(1, 'weeks').endOf('isoWeek'),
    ],
    'This Month': () => [moment().startOf('month'), moment().endOf('month')],
    'Last Month': () => [
        moment().subtract(1, 'months').startOf('month'),
        moment().subtract(1, 'months').endOf('month'),
    ],
};

export const executorDateRanges = {
    'Last 6 Months': () => [moment().subtract(6, 'months').startOf('day'), moment().endOf('day')],
    'Last Year': () => [moment().subtract(1, 'year').startOf('day'), moment().endOf('day')],
};

export const dateRangesOnline = {
    Today: () => [moment().startOf('day'), moment().endOf('day')],
    Yesterday: () => [moment().subtract(1, 'day').startOf('day'), moment().subtract(1, 'day').endOf('day')],
    'Last Week': () => [
        moment().subtract(1, 'weeks').startOf('isoWeek'),
        moment().subtract(1, 'weeks').endOf('isoWeek'),
    ],
    'This Month': () => [moment().startOf('month'), moment().endOf('month')],
    'Last Month': () => [
        moment().subtract(1, 'months').startOf('month'),
        moment().subtract(1, 'months').endOf('month'),
    ],
    'Last 1o days': () => [moment().subtract(10, 'day').startOf('day'), moment().endOf('day')],
    'Last 3o days': () => [moment().subtract(30, 'day').startOf('day'), moment().endOf('day')],
    'Last 18o days': () => [moment().subtract(180, 'day').startOf('day'), moment().endOf('day')],
    'Last year': () => [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')],
};

export const playerDateRanges = {
    Today: () => [moment().startOf('day'), moment().endOf('day')],
    Yesterday: () => [moment().subtract(1, 'day').startOf('day'), moment().subtract(1, 'day').endOf('day')],
    'This Week': () => [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
    'Last Week': () => [
        moment().subtract(1, 'weeks').startOf('isoWeek'),
        moment().subtract(1, 'weeks').endOf('isoWeek'),
    ],
    'This Month': () => [moment().startOf('month'), moment().endOf('month')],
    'Last Month': () => [
        moment().subtract(1, 'months').startOf('month'),
        moment().subtract(1, 'months').endOf('month'),
    ],
    'Last 6 Months': () => [moment().subtract(6, 'months').startOf('day'), moment().endOf('day')],
    'Last Year': () => [moment().subtract(1, 'year').startOf('day'), moment().endOf('day')],
};

export const defaultTimeValues = {
    format: 'HH:mm:ss',
    defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
};

export const languages = ['eng', 'aze'];

export const MARKET_GROUPS_ALL_ID = 'all';

export const MARKET_TYPES = {
    integer: 'integer',
    float: 'float',
    asian: 'asian',
};

export const FILTER_PARAMS = {
    accountNumber: 'accountNumber',
    agentId: 'agentId',
    amountType: 'amountType',
    betLinesCount: 'count',
    cashierCode: 'cashierCode',
    category: 'category',
    categoryId: 'categoryId',
    categoryIds: 'categoryIds',
    changedBalance: 'changedBalance',
    channel: 'channel',
    clientType: 'clientType',
    clientTypes: 'clientTypes',
    competitionType: 'competitionType',
    producerType: 'producerType',
    competitionTypeId: 'competitionTypeId',
    country: 'country',
    customerId: 'customerId',
    customerTag: 'customerTag',
    dateType: 'dateType',
    endAmount: 'endAmount',
    endDate: 'endDate',
    event: 'event',
    eventId: 'eventId',
    day: 'day',
    declineType: 'declineType',
    eventIds: 'eventIds',
    eventSearch: 'eventSearch',
    eventTypeId: 'eventTypeId',
    errorCode: 'errorCode',
    executor: 'executor',
    ticketOperationStatus: 'status',
    freezeType: 'freezeType',
    labelId: 'labelId',
    lastXMinutes: 'lastXMinutes',
    lastXOperations: 'lastXOperations',
    lastXPlacedBets: 'lastXPlacedBets',
    groupBy: 'groupBy',
    league: 'league',
    leagueId: 'leagueId',
    leagueIds: 'leagueIds',
    limit: 'limit',
    loginFailureReason: 'loginFailureReason',
    paymentStatus: 'paymentStatus',
    paymentType: 'paymentType',
    phone: 'phone',
    playerCurrentStatus: 'playerCurrentStatus',
    month: 'month',
    operationGroups: 'operationGroups',
    player: 'player',
    isManual: 'isManual',
    programCode: 'programCode',
    range: 'range',
    secondaryGroupBy: 'secondaryGroupBy',
    selectionCounts: 'outcomeColumnLength',
    secondGroupBy: 'secondGroupBy',
    size: 'size',
    channelType: 'channelType',
    specifier: 'specifier',
    operatingSystem: 'operatingSystem',
    segmentIds: 'segmentIds',
    uniquePlayer: 'uniquePlayer',
    actionType: 'actionType',
    customerIds: 'customerIds',
    tags: 'tags',
    testUser: 'testUser',
    keyword: 'keyword',
    transactionId: 'transactionId',
    merchantOrderId: 'merchantOrderId',
    startDate: 'startDate',
    ticketType: 'ticketType',
    competitionTypes: 'competitionTypes',
    sport: 'sport',
    sportId: 'sportId',
    sportTypeId: 'sportTypeId',
    tournaments: 'tournaments',
    marketId: 'marketId',
    marketHash: 'marketHash',
    marketRefIds: 'marketRefIds',
    marketRefId: 'marketRefId',
    startAmount: 'startAmount',
    ticketSubStatus: 'ticketSubStatus',
    ticketId: 'ticketId',
    mainGroupBy: 'mainGroupBy',
    payment: 'payment',
    pageSize: 'pageSize',
    logType: 'type',
    week: 'week',
    mbn: 'mbn',
    requestId: 'requestId',
    tournamentId: 'tournamentId',
    tournamentIds: 'tournamentIds',
    oddRange: 'oddRange',
    markets: 'markets',
    marketGroupLabelId: 'marketGroupLabelId',
    status: 'status',
    outcomeRefId: 'outcomeRefId',
    ticketCode: 'ticketCode',
    fullName: 'fullName',
    operator: 'operator',
    success: 'success',
    tier: 'tournamentGroupId',
    ipAddr: 'ipAddr',
    tfcUser: 'tfcUser',
    ticket_code: 'ticket_code',
    ticket_id: 'ticket_id',
    ticketOperationType: 'operationType',
    market: 'market',
    outcomes: 'outcomes',
    showOnlyPositiveRealBalance: 'showOnlyPositiveRealBalance',
    showOnlyPendingCasinoBets: 'showOnlyPendingCasinoBets',
    enablePaging: 'enablePaging',
    balanceType: 'balanceType',
    balance: 'balance',
    affiliateTag: 'affiliateTag',
    userName: 'userName',
    uniqueData: 'uniqueData',
    freeBets: 'freeBets',
    sportLevel: 'sportLevel',
    operators: 'operators',
    agentName: 'agentName',
    application: 'application',
    agentUsername: 'agentUsername',
    agentFullName: 'agentFullName',
    agentIpAddress: 'agentIpAddress',
    playerUsername: 'playerUsername',
    playerFullName: 'playerFullName',
    playerId: 'playerId',
    action: 'action',
    actionLabels: 'actionLabels',
    emailAddress: 'emailAddress',
    permission: 'permission',
    nickname: 'nickname',
    userRole: 'userRole',
    accessStatus: 'accessStatus',
    mfaStatus: 'mfaStatus',
    date: 'date',
    isDeposited: 'isDeposited',
    emailMobileVerification: 'emailMobileVerification',
    operatingSystemTypes: 'operatingSystemTypes',
    channelOnline: 'channel',
    operationGroup: 'operationGroup',
    name: 'name',
    loginIpAddress: 'loginIpAddress',
    loginStatus: 'loginStatus',
    loginCountry: 'loginCountry',
    internalTransactionId: 'internalTransactionId',
    ruleSetName: 'ruleSetName',
    verificationStatus: 'verificationStatus',
    paymentMethod: 'paymentMethod',
    paymentMethods: 'paymentMethods',
    withdrawalAmountMin: 'withdrawalAmountMin',
    withdrawalAmountMax: 'withdrawalAmountMax',
    lifetimeDepositAmountMin: 'lifetimeDepositAmountMin',
    lifetimeDepositAmountMax: 'lifetimeDepositAmountMax',
    lifetimeWDMin: 'lifetimeWDMin',
    lifetimeWDMax: 'lifetimeWDMax',
    image: 'image',
    title: 'title',
    description: 'description',
    lastName: 'lastName',
    content: 'content',
    totalOdds: 'totalOdds',
    countOfActiveLines: 'countOfActiveLines',
    isLive: 'isLive',
    outcomeId: 'outcomeId',
    marketIds: 'marketIds',
    showBanner: 'showBanner',
    showPromotion: 'showPromotion',
    processStatus: 'processStatus',
    deposited: 'deposited',
    manualOperationAfterWD: 'manualOperationAfterWD',
    sixMonthsAML: 'sixMonthsAML',
    priorityNotes: 'priorityNotes',
    freeSpins: 'freeSpins',
    sportBonus: 'sportBonus',
    casinoBonus: 'casinoBonus',
    sportCasinoTransfer: 'sportCasinoTransfer',
    negativeSportBalance: 'negativeSportBalance',
    negativeCasinoBalance: 'negativeCasinoBalance',
    lifetimeSportTurnoverMin: 'lifetimeSportTurnoverMin',
    lifetimeSportTurnoverMax: 'lifetimeSportTurnoverMax',
    lifetimeCasinoTurnoverMin: 'lifetimeCasinoTurnoverMin',
    lifetimeCasinoTurnoverMax: 'lifetimeCasinoTurnoverMax',
    lowRiskBetsAfterLastDepositMin: 'lowRiskBetsAfterLastDepositMin',
    lowRiskBetsAfterLastDepositMax: 'lowRiskBetsAfterLastDepositMax',
    betsAfterLastDeposit: 'betsAfterLastDeposit',
    sportWinningOddsMin: 'sportWinningOddsMin',
    sportWinningOddsMax: 'sportWinningOddsMax',
    casinoWinningOddsMin: 'casinoWinningOddsMin',
    casinoWinningOddsMax: 'casinoWinningOddsMax',
    mainMarket: 'mainMarket',
    isUniquePlayer: 'isUniquePlayer',
    paymentProvider: 'paymentProvider',
    source: 'source',
    paymentProviders: 'paymentProviders',
    sportsLevel: 'sportLevel',
    systemInitiated: 'systemInitiated',
    marketHashes: 'marketHashes',
    walletTypes: 'walletTypes',
    balanceActivity: 'balanceActivity',
    activityRange: 'activityRange',
    startDateActivity: 'startDateActivity',
    endDateActivity: 'endDateActivity',
    activity: 'activity',
    balanceAmountFilter: 'balanceAmountFilter',
    account: 'account',
    sportConditions: 'sportConditions',
    contribution: 'contribution',
    numberOfBetsRequired: 'numberOfBetsRequired',
    conditionType: 'conditionType',
    qualifyingConditionEnabled: 'qualifyingConditionEnabled',
    depositWageringMultiplier: 'depositWageringMultiplier',
    expirationTimeType: 'expirationTimeType',
    expirationTimeValue: 'expirationTimeValue',
    redeemAsCashEnabled: 'redeemAsCashEnabled',
    bonusAmountEnabled: 'bonusAmountEnabled',
    depositAmountEnabled: 'depositAmountEnabled',
    moneyToWagerWithType: 'moneyToWagerWithType',
    bonusWageringMultiplier: 'bonusWageringMultiplier',
    bonusAmountType: 'bonusAmountType',
    maximumBonusWinningsEnabled: 'maximumBonusWinningsEnabled',
    maximumBonusAmount: 'maximumBonusAmount',
    minimumStakeAmount: 'minimumStakeAmount',
    minDepositAmount: 'minDepositAmount',
    minimumDepositAmount: 'minimumDepositAmount',
    maximumFreeBetAmount: 'maximumFreeBetAmount',
    percentage: 'percentage',
    bonusWinningsLimitType: 'bonusWinningsLimitType',
    bonusWinningsLimitValue: 'bonusWinningsLimitValue',
    fixedBonusAmount: 'fixedBonusAmount',
    freeBetAmount: 'freeBetAmount',
    bonuses: 'bonuses',
    bonusName: 'bonusName',
    bonusType: 'bonusType',
    timesAllowedPerPlayer: 'timesAllowedPerPlayer',
    welcomeBonusEnabled: 'welcomeBonusEnabled',
    riskFreeBetEnabled: 'riskFreeBetEnabled',
    notAllowOtherBonus: 'notAllowOtherBonus',
    allowedMultiAccount: 'allowedMultiAccount',
    wagerSameSelectionBetsEnabled: 'wagerSameSelectionBetsEnabled',
    duplicateSportBetsLogicType: 'duplicateSportBetsLogicType',
    filters: 'filters',
    playerSegment: 'playerSegment',
    operationType: 'operationType',
    value1: 'value1',
    value2: 'value2',
    group: 'group',
    limitType: 'limitType',
    daily: 'daily',
    weekly: 'weekly',
    monthly: 'monthly',
    total: 'total',
    uploadFile: 'uploadFile',
    cancelWaitingOffers: 'cancelWaitingOffers',
    marketSubtype: 'marketSubtype',
    includeBonusMoneyBets: 'includeBonusMoneyBets',
    showInCashier: 'showInCashier',
    active: 'active',
    offerLimitType: 'numberOfOffersType',
    offerCount: 'offerCount',
    maxDailyOffers: 'maxDailyOffers',
    maxWeeklyOffers: 'maxWeeklyOffers',
    maxMonthlyOffers: 'maxMonthlyOffers',
    totalOffers: 'totalOffers',
    dailyStartTime: 'dailyStartTime',
    dailyEndTime: 'dailyEndTime',
    daysOfWeek: 'daysOfWeek',
    uploadFileType: 'uploadFileType',
    file: 'file',
    type: 'type',
    documents: 'documents',
    timesAllowedPerCustomer: 'timesAllowedPerCustomer',
    activityPeriod: 'activityPeriod',
    minDaysFrom: 'minDaysFrom',
    maxDaysTo: 'maxDaysTo',
    calculationBased: 'calculationBased',
    targetGroupControls: 'targetGroupControls',
    position: 'position',
    minimumQualifyingAmount: 'minimumQualifyingAmount',
    maximumQualifyingAmount: 'maximumQualifyingAmount',
    bonusAmount: 'bonusAmount',
    secondCondition: 'secondCondition',
    thirdCondition: 'thirdCondition',
    kpiCalculationType: 'kpiCalculationType',
    value: 'value',
    lengthCode: 'lengthCode',
    code: 'code',
    subCodes: 'subCodes',
    subCodesDateRange: 'subCodesDateRange',
    length: 'length',
    number: 'number',
    prefix: 'prefix',
    startTime: 'startTime',
    segmentPeriods: 'segmentPeriods',
    segment: 'segment',
    repeatEvery: 'repeatEvery',
    stopRepeat: 'stopTimeType',
    afterOccurrences: 'afterOccurrences',
    stopTime: 'stopTime',
    repeatType: 'repeatType',
    repeatOn: 'repeatOn',
    paymentClientType: 'paymentClientType',
    availableAnySportEnabled: 'availableAnySportEnabled',
    selections: 'selections',
    selection: 'selection',
    setLimit: 'setLimit',
    limitValue: 'limitValue',
    qualifyingWageringRequirementType: 'qualifyingWageringRequirementType',
    depositAmountMultiplier: 'depositAmountMultiplier',
    fixedTurnoverAmount: 'fixedTurnoverAmount',
    countFirstBetOnlyEnabled: 'countFirstBetOnlyEnabled',
    qualifyingFulfillmentDetailsType: 'qualifyingFulfillmentDetailsType',
    qualifyingFulfillmentDetailsValue: 'qualifyingFulfillmentDetailsValue',
    qualifyingBetStatus: 'qualifyingBetStatus',
    showInactive: 'showInactive',
    bonusId: 'bonusId',
    promotionIssuingType: 'issuingType',
    trigger: 'trigger',
    playerListInclusionStatus: 'playerListInclusionStatus',
    totalTurnover: 'totalTurnover',
    freeBetCriteria: 'freeBetCriteria',
    targetPlayers: 'targetPlayers',
    testAccounts: 'testAccounts',
    executionDate: 'executionDate',
    gameplayCriteria: 'gameplayCriteria',
    betType: 'betType',
    betId: 'betId',
    criteriaList: 'criteriaList',
    bonusStatus: 'bonusStatus',
    issuingMethod: 'issuingMethod',
    financialParameters: 'financialParameters',
    bonusCode: 'bonusCode',
    bonusTypeId: 'bonusTypeId',
    customerBonusId: 'customerBonusId',
    firstName: 'firstName',
    reasonType: 'reasonType',
    userBonusId: 'userBonusId',
    sportParams: 'sportParams',
    betParams: 'betParams',
    values: 'values',
    enableGettingMoreThanOne: 'enableGettingMoreThanOne',
    wageringRequirement: 'wageringRequirement',
    segmentId: 'segmentId',
    amount: 'amount',
    link: 'link',
    overwriteBonusValue: 'overwriteBonusValue',
    playerSearch: {
        accountRelated: {
            accountNumber: 'accountRelated.accountNumber',
            registrationTime: {
                start: 'accountRelated.registrationTime.start',
                end: 'accountRelated.registrationTime.end',
                base: 'accountRelated.registrationTime',
            },
            kycVerificationStatus: 'accountRelated.KYCVerificationStatus',
            playerStatus: 'accountRelated.playerStatus',
            emailMobileVerification: 'accountRelated.emailMobileVerification',
            lastDocUploaded: {
                start: 'accountRelated.lastDocumentUploadedTime.start',
                end: 'accountRelated.lastDocumentUploadedTime.end',
                base: 'accountRelated.lastDocUploaded',
            },
        },
        personalDetails: {
            firstName: 'personalDetails.firstName',
            lastName: 'personalDetails.lastName',
            email: 'personalDetails.emailAddress',
            dateOfBirthTime: 'personalDetails.dateOfBirthTime',
            phoneNumber: 'personalDetails.phoneNumber',
            gender: 'personalDetails.gender',
            identityDocumentNumber: 'personalDetails.identityDocumentNumber',
        },
        payments: {
            firstDepositDate: {
                start: 'payments.firstDepositDate.start',
                end: 'payments.firstDepositDate.end',
                base: 'payments.firstDepositDate',
            },
            lastDepositDate: {
                start: 'payments.lastDepositDate.start',
                end: 'payments.lastDepositDate.end',
                base: 'payments.lastDepositDate',
            },
            firstDepositAmount: {
                base: 'payments.firstDepositAmount',
                type: 'payments.firstDepositAmount.operationType',
                amount: 'payments.firstDepositAmount.amount',
            },
            lastDepositAmount: {
                base: 'payments.lastDepositAmount',
                type: 'payments.lastDepositAmount.operationType',
                amount: 'payments.lastDepositAmount.amount',
            },
            singleMinDepositAmount: {
                base: 'payments.singleMinDepositAmount',
                type: 'payments.singleMinDepositAmount.operationType',
                amount: 'payments.singleMinDepositAmount.amount',
            },
            singleMaxDepositAmount: {
                base: 'payments.singleMaxDepositAmount',
                type: 'payments.singleMaxDepositAmount.operationType',
                amount: 'payments.singleMaxDepositAmount.amount',
            },
            totalDepositAmount: {
                base: 'payments.totalDepositAmount',
                type: 'payments.totalDepositAmount.operationType',
                amount: 'payments.totalDepositAmount.amount',
            },
            averageDepositAmount: {
                base: 'payments.averageDepositAmount',
                type: 'payments.averageDepositAmount.operationType',
                amount: 'payments.averageDepositAmount.amount',
            },
            depositCount: {
                base: 'payments.depositCount',
                type: 'payments.depositCount.operationType',
                amount: 'payments.depositCount.amount',
            },
        },
        gaming: {
            lastSportsPlayed: {
                start: 'gaming.lastSportsPlayed.start',
                end: 'gaming.lastSportsPlayed.end',
                base: 'gaming.lastSportsPlayed',
            },
            sportsBalance: {
                base: 'gaming.sportsBalance',
                type: 'gaming.sportsBalance.operationType',
                amount: 'gaming.sportsBalance.amount',
            },
            turnover: {
                base: 'gaming.turnover',
                type: 'gaming.turnover.operationType',
                amount: 'gaming.turnover.amount',
            },
            ggr: {
                base: 'gaming.ggr',
                type: 'gaming.ggr.operationType',
                amount: 'gaming.ggr.amount',
            },
        },
        bonuses: {
            lastBonusAmount: {
                base: 'bonuses.lastBonusAmount',
                type: 'bonuses.lastBonusAmount.operationType',
                amount: 'bonuses.lastBonusAmount.amount',
            },
            bonusGiven: {
                base: 'bonuses.bonusGiven',
                type: 'bonuses.bonusGiven.operationType',
                amount: 'bonuses.bonusGiven.amount',
            },
            bonusSpent: {
                base: 'bonuses.bonusSpent',
                type: 'bonuses.bonusSpent.operationType',
                amount: 'bonuses.bonusSpent.amount',
            },
            lastBonusGiven: {
                start: 'bonuses.lastBonusGiven.start',
                end: 'bonuses.lastBonusGiven.end',
                base: 'bonuses.lastBonusGiven',
            },
            lastFreeBetGiven: {
                start: 'bonuses.lastFreeBetGiven.start',
                end: 'bonuses.lastFreeBetGiven.end',
                base: 'bonuses.lastFreeBetGiven',
            },
            bonusBlocked: {
                base: 'bonuses.bonusBlocked',
            },
        },
        responsibleGaming: {
            selfExclusionStart: {
                start: 'responsibleGaming.selfExclusionStart.start',
                end: 'responsibleGaming.selfExclusionStart.end',
                base: 'responsibleGaming.selfExclusionStart',
            },
            selfExclusionEnd: {
                start: 'responsibleGaming.selfExclusionEnd.start',
                end: 'responsibleGaming.selfExclusionEnd.end',
                base: 'responsibleGaming.selfExclusionEnd',
            },
        },
        tracking: {
            registrationIp: 'tracking.registrationIp',
            multiAccounts: 'tracking.multiAccounts',
            customerTags: 'tracking.customerTags',
            clientType: 'tracking.clientType',
            lastLoginDate: {
                start: 'tracking.lastLoginDate.start',
                end: 'tracking.lastLoginDate.end',
                base: 'tracking.lastLoginDate',
            },
        },
    },
    visibilityUsers: 'visibilityUsers',
    resultType: 'resultType',
    eventOrBetId: 'eventOrBetId',
    promotionOrBonusId: 'promotionOrBonusId',
    eventType: 'eventType',
    financialParameter: 'financialParameter',
    financialAmountType: 'financialAmountType',
    promotionId: 'promotionId',
    promotionName: 'promotionName',
    accounts: 'accounts',
    dateFilterType: 'dateFilterType',
    promotionType: 'promotionType',
    promotionStatus: 'promotionStatus',
    promotionTrigger: 'promotionTrigger',
    promotionShowInCashier: 'promotionShowInCashier',
    username: 'username',
    ipAddress: 'ipAddress',
    reqContentKeyword: 'reqContentKeyword',
    operationDescriptionId: 'operationDescriptionId',
    order: 'order',
    ticketStatus: 'ticketStatus',
    conditions: 'conditions',
    segmentConditionType: 'segmentConditionType',
    isManual: 'isManual',
    segmentName: 'segmentName',
    applicationType: 'applicationType',
    notificationCount: 'notificationCount',
    notificationInterval: 'notificationInterval',
    version: 'version',
    isForceUpdate: 'isForceUpdate',
    apkFile: 'apkFile',
    internalPage: 'internalPage',
    externalUrl: 'externalUrl',
    bonusBlocked: 'bonusBlocked',
};

export const SELECT_ALL_OPTION = {
    optionalValue: 0,
    value: 'All',
    name: 'All',
};

export const ODD_RANGES = ['<1.20', '1.20-1.50', '1.51-2.00', '2.01-3.00', '3.01-5.00', '>5.00'];

export const LOG_TYPES = [
    {
        id: 1,
        label: 'Debt',
    },
    {
        id: 2,
        label: 'Credit',
    },
    {
        id: 3,
        label: 'Interim Payment',
    },
    {
        id: 4,
        label: 'Sold Ticket',
    },
    {
        id: 5,
        label: 'Paid Ticket',
    },
    {
        id: 6,
        label: 'Cancelled Ticket',
    },
    {
        id: 7,
        label: 'Extra Debt/Credit',
    },
    {
        id: 8,
        label: 'BO Balance Increase/Decrease',
    },
];

export const GROUP_BY_OPTIONS = {
    registrationsHistory: {
        groupBy: 'REGISTRATION_HISTORY_GROUP_BY',
    },
    gamingActivity: {
        groupBy: 'GAMING_ACTIVITY_GROUP_BY',
    },
    netCashReport: {
        groupBy: 'NET_CASH_GROUP_BY',
    },
    playerActivityReport: {
        groupBy: 'PLAYER_ACTIVITY_GROUP_BY',
    },
};

export const PAGINATION_KEYS = {
    accountingPeriodsRecord: 'accountingPeriodsRecord',
    accountingReport: 'accountingReport',
    banners: 'banners',
    betsHistory: 'betsHistory',
    betsMonitor: 'betsMonitor',
    cashierLoginHistory: 'cashierLoginHistory',
    cashierTicketLogs: 'cashierTicketLogs',
    cashierTransactionLogs: 'cashierTransactionLogs',
    categoryWeights: 'categoryWeights',
    combinationLocks: 'combinationLocks',
    depositsWithdrawals: 'depositsWithdrawalsManager',
    declinedBetsHistory: 'declinedBetsHistory',
    featuredLinks: 'featuredLinks',
    frozenAccountsReport: 'frozenAccountsReport',
    gamingActivityFirstGroupData: 'gamingActivityFirstGroupData',
    gamingActivitySecondGroupData: 'gamingActivitySecondGroupData',
    gamingActivityThirdGroupData: 'gamingActivityThirdGroupData',
    leagueWeights: 'leagueWeights',
    loginsHistory: 'loginsHistory',
    logs: 'logs',
    marketGroups: 'marketGroups',
    markets: 'markets',
    messages: 'messages',
    messageRecipients: 'messageRecipients',
    monitoringOutrightEvents: 'monitoringOutrightEvents',
    monitoringRegularEvents: 'monitoringRegularEvents',
    operationLogs: 'operationLogs',
    outcomes: 'outcomes',
    settlementTickets: 'settlementTickets',
    sportWeights: 'sportWeights',
    moneyTransactions: 'moneyTransactions',
    netCashReportFirstGroup: 'netCashReportFirstGroup',
    netCashReportSecondGroup: 'netCashReportSecondGroup',
    onlinePlayersReport: 'onlinePlayersReport',
    taxReturnReport: 'taxReturnReport',
    taxTurnoverReport: 'taxTurnoverReport',
    terminalLoginHistory: 'terminalLoginHistory',
    terminalTicketLogs: 'terminalTicketLogs',
    terminalTransactionLogs: 'terminalTransactionLogs',
    transactions: 'transactions',
    withdrawalAutoprocessingRules: 'withdrawalAutoprocessingRules',
    registrationsHistory: 'registrationsHistory',
    playerActivityReportMainGroup: 'playerActivityReportMainGroup',
    playerActivityReportSecondaryGroup: 'playerActivityReportSecondaryGroup',
    playerSegmentation: 'playerSegmentation',
    playerSegmentationReport: 'playerSegmentationReport',
    inactivePlayersReport: 'inactivePlayersReport',
    bonuses: 'bonuses',
    bonusWageringReport: 'bonusWageringReport',
    bonusEngineMonitor: 'bonusEngineMonitor',
    playerBonusesReport: 'playerBonusesReport',
    playerBonusReport: 'playerBonusReport',
    playerSearch: 'playerSearch',
    ticketOperationsHistory: 'ticketOperationsHistory',
    bonusOffersReport: 'bonusOffersReport',
    promotions: 'promotions',
    promotionBonusOffers: 'promotionBonusOffers',
    auditTrailReport: 'auditTrailReport',
    updateVersions: 'updateVersions',
};

export const API_ERROR_CODES = {
    manualTicketSettlementInvalidTicketStatus: 'GE:000019',
    manualTicketSettlementFailedToUpdate: 'GE:000019',
};

export const MESSAGE_PRIORITIES = [
    {
        value: 1,
        label: 'Low',
    },
    {
        value: 2,
        label: 'High',
    },
];

export const ACTION_BLOCK_TYPES = {
    betBlock: 'BET_BLOCK',
    liveBetBlock: 'LIVE_BET_BLOCK',
    preMatchBetBlock: 'PRE_MATCH_BET_BLOCK',
    cancelBlock: 'CANCEL_BLOCK',
    paymentBlock: 'PAYMENT_BLOCK',
};

export const CANCEL_TOKEN_KEYS = {
    betsHistory: 'BETS_HISTORY',
    betsMonitor: 'BETS_MONITOR',
    gamingActivity: 'GAMING_ACTIVITY',
    salesReports: 'SALES_REPORTS',
    settlementMarkets: 'SETTLEMENT_MARKETS',
    settlementTickets: 'SETTLEMENT_TICKETS',
    sportsPerformance: 'SPORTS_PERFORMANCE',
    ticketOperationsHistory: 'TICKET-OPERATIONS-HISTORY',
};

export const EMAIL_ADDRESSES_FIELDS = {
    description: 'Description',
    email: 'Email Address',
    names: 'Email Groups',
};

export const EMAIL_GROUPS_FIELDS = {
    name: 'Name',
    description: 'Description',
};

export const USER_FIELDS = {
    email: 'Email',
    firstName: 'First Name',
    lastName: 'Last Name',
    password: 'Password',
    statusId: 'Status',
    userName: 'Username',
};

export const SERVER_ERRORS_LOGS_FIELDS = {
    aze: 'Error Reason Aze',
    eng: 'Error Reason Eng',
    errorName: 'Name',
    errorCode: 'Code',
    errorDescription: 'Description',
    errorReason: 'Reason',
    serviceName: 'Service Name',
};

export const KYC_LOGS_FIELDS = {
    id: 'Document ID',
    fileType: 'Document Type',
    note: 'Note',
    status: 'Status',
    submissionType: 'Submission Type',
    validTill: 'Valid Till',
    documentNumber: 'Document Number',
    sideType: 'Side Type',
    documents: 'Documents',
};

export const SELF_EXCLUDE_FIELDS = {
    status: 'Status',
    selfExcluded: 'Self-Excluded',
    startTime: 'Start Time',
    endTime: 'End Time',
};

export const PLAYER_UPDATE_FIELDS = {
    address: 'Address',
    cityId: 'City',
    dateOfBirth: 'Date Of Birth',
    email: 'Email',
    firstName: 'First Name',
    genderId: 'Gender',
    lastName: 'Last name',
    occupation: 'Occupation',
    phone: 'Phone',
};

export const isProd = window.location.hostname.includes('omt.etopaz.az');

export const RETAIL_APPS = {
    cashier: {
        value: 'cashier',
        label: 'Cashier',
        domain: 'cashier',
    },
    ssbt: {
        value: 'ssbt',
        label: 'SSBT',
        domain: 'bb',
    },
    liveTv: {
        value: 'liveTv',
        label: 'Live TV',
        domain: 'ltv',
    },
    mt: {
        value: 'mt',
        label: 'MT',
        domain: 'mt',
    },
    ozbetDevice: {
        value: 'ozbet-device',
        label: 'Özbet Device',
    },
};

export const ONLINE_APPS = {
    onlineWeb: {
        value: 'online-web',
        label: 'Online',
        domain: 'online',
    },
    mt: {
        value: 'mt',
        label: 'MT',
        domain: 'mt',
    },
};

const buildAppUrl = appName => {
    return `https://${isProd ? '' : 'st'}${appName}.topaz.net.az`;
};

export const APP_URLS = {
    [RETAIL_APPS.cashier.value]: buildAppUrl(RETAIL_APPS.cashier.domain),
    [RETAIL_APPS.ssbt.value]: buildAppUrl(RETAIL_APPS.ssbt.domain),
    [RETAIL_APPS.liveTv.value]: buildAppUrl(RETAIL_APPS.liveTv.domain),
    [RETAIL_APPS.mt.value]: buildAppUrl(RETAIL_APPS.mt.domain),
    [ONLINE_APPS.onlineWeb.value]: buildAppUrl(ONLINE_APPS.onlineWeb.domain),
};

export const FAILURE_REASON_OPTION = [
    { value: 'NONE', label: 'None' },
    { value: 'UNKNOWN', label: 'Unknown' },
    { value: 'BAD_CREDENTIALS', label: 'Wrong credentials' },
    { value: 'PLAYER_IS_BLOCKED', label: 'Player is blocked' },
];

export const STATUS_OPTIONS = [
    { value: 'true', label: 'Successful' },
    { value: 'false', label: 'Failed' },
];

export const COUNTRY_OPTIONS = [{ value: 'AZ', label: 'Azerbaijan' }];

export const USER_OPTIONS = [
    {
        value: 'ALL',
        label: 'All',
    },
    {
        value: 'RETAIL',
        label: 'Retail',
    },
    {
        value: 'MOBILE_USER',
        label: 'Mobile User',
    },
];

export const BANNER_TYPES_ENUM = {
    betBanner: 'BET_BANNER',
    promotion: 'PROMOTION',
    couponBanner: 'COUPON_BANNER',
    featuredLink: 'FEATURED_LINK',
};

export const COUPON_BANNER_SELECTIONS_TABLE_COLUMNS = {
    sportName: {
        key: 'sportName',
        label: 'Sport',
    },
    categoryName: {
        key: 'categoryName',
        label: 'Category',
    },
    leagueName: {
        key: 'leagueName',
        label: 'League',
    },
    eventName: {
        key: 'eventName',
        label: 'Event',
    },
    marketName: {
        key: 'marketName',
        label: 'Market',
    },
    outcomeName: {
        key: 'outcomeName',
        label: 'Outcome',
    },
    outcomeOdd: {
        key: 'outcomeOdd',
        label: 'Odd',
    },
};

export const COUPON_BANNER_TABLE_COLUMNS = {
    title: {
        key: 'title',
        label: 'Title',
    },
    totalOdds: {
        key: 'totalOdds',
        label: 'Total Odds',
    },
};

export const BANNER_STATUSES = [
    {
        value: 'ACTIVE',
        label: 'ACTIVE',
    },
    {
        value: 'INACTIVE',
        label: 'INACTIVE',
    },
];

export const PAYMENT_STATUSES = {
    inProgress: {
        value: 'IN_PROGRESS',
        label: 'In Progress',
    },
    pending: {
        value: 'PENDING',
        label: 'Pending',
    },
    confirmed: {
        value: 'CONFIRMED',
        label: 'Confirmed',
    },
    declined: {
        value: 'DECLINED',
        label: 'Declined',
    },
    cancelled: {
        value: 'CANCELLED',
        label: 'Cancelled',
    },
};

export const PAYMENT_TYPES = {
    deposit: { id: 1, value: 'DEPOSIT', label: 'Deposit' },
    withdraw: { id: 2, value: 'WITHDRAW', label: 'Withdraw' },
    manualWithdrawals: { id: 3, value: 'MANUAL_WITHDRAW', label: 'Manual withdraw' },
    manualDeposits: { id: 4, value: 'MANUAL_DEPOSIT', label: 'Manual deposit' },
};

export const ORDER_DECLINE_REASONS = [
    { label: 'Fraud', value: 'FRAUD' },
    { label: 'Other', value: 'OTHER' },
];

export const ONLINE_PLAYERS_REPORT_COLUMNS = {
    customerId: {
        key: 'customerId',
        label: 'Customer ID',
    },
    operator: {
        key: 'operator',
        label: 'Operator',
    },
    vipLevel: {
        key: 'vipLevel',
        label: 'Vip - Level',
    },
    sportsLevel: {
        key: 'sportsLevel',
        label: 'Sports Level',
    },
    clientType: {
        key: 'clientType',
        label: 'Client-Type',
    },
    country: {
        key: 'country',
        label: 'Country',
    },
    product: {
        key: 'product',
        label: 'Product',
    },
    sportBalance: {
        key: 'sportBalance',
        label: 'Sport Balance',
    },
    lifetimeDeposits: {
        key: 'lifetimeDeposits',
        label: 'Lifetime Deposits',
    },
    lifetimeWithdrawals: {
        key: 'lifetimeWithdrawals',
        label: 'Lifetime Withdrawals',
    },
    openBets: {
        key: 'openBets',
        label: 'Open Bets',
    },
    ggr: {
        key: 'ggr',
        label: 'GGR',
    },
    loggedInFor: {
        key: 'loggedInFor',
        label: 'Logged in for',
    },

    totalBalance: {
        key: 'totalBalance',
        label: 'Total Balance',
    },
    sportBonuses: {
        key: 'sportBonuses',
        label: 'Sport Bonuses',
    },
    totalPlayer: {
        key: 'totalPlayer',
        label: 'Total Player',
    },
};

export const DECLINE_TYPE_OPTIONS = [
    {
        label: 'Customer Declined',
        value: 'CUSTOMER_DECLINE',
    },
    {
        label: 'Failed',
        value: 'FAILED',
    },
    {
        label: 'System Declined',
        value: 'SYSTEM_DECLINE',
    },
    {
        label: 'Trader Declined',
        value: 'TRADER_DECLINE',
    },
];

export const DECLINED_BETS_HISTORY_BET_LINES_TABLE_COLUMNS = {
    sportName: {
        key: 'sportName',
        label: 'Sport',
    },
    leagueName: {
        key: 'leagueName',
        label: 'League',
    },
    eventName: {
        key: 'eventName',
        label: 'Event',
    },
    scheduleDate: {
        key: 'scheduleDate',
        label: 'Event Date',
    },
    marketName: {
        key: 'marketName',
        label: 'Market',
    },
    stakeAmount: {
        key: 'stakeAmount',
        label: 'Stake',
    },
    currentOdd: {
        key: 'currentOdd',
        label: 'Odd',
    },
    banco: {
        key: 'banco',
        label: 'Banco',
    },
    stake: {
        key: 'stake',
        label: 'Stake',
    },
    declined: {
        key: 'declined',
        label: 'Declined',
    },
};

export const NET_CASH_REPORT_LOGS_TABLE_COLUMNS = {
    date: {
        key: 'date',
        label: 'Date',
    },
    transactionId: {
        key: 'transactionId',
        label: 'Transaction ID',
    },
    paymentMethod: {
        key: 'paymentMethod',
        label: 'Payment Method',
    },
    paymentProvider: {
        key: 'paymentProvider',
        label: 'Payment Provider',
    },
    type: {
        key: 'type',
        label: 'Type',
    },
    amount: {
        key: 'amount',
        label: 'Amount',
    },
    clientType: {
        key: 'clientType',
        label: 'Client Type',
    },
    customerId: {
        key: 'customerId',
        label: 'Customer ID ',
    },
};

export const CHANNEL_OPTIONS = [
    {
        value: 1,
        label: 'SEO',
    },
    {
        value: 2,
        label: 'Direct',
    },
    {
        value: 3,
        label: 'Media',
    },
    {
        value: 4,
        label: 'Other',
    },
];

export const DEPOSITED_NOT_DEPOSITED_OPTIONS = [
    { value: true, label: 'Deposited' },
    { value: false, label: 'Not Deposited' },
];

export const EMAIL_MOBILE_VERIFICATION_OPTIONS = [
    {
        value: 'EMAIL_VERIFIED',
        label: 'Email Verified',
    },
    {
        value: 'EMAIL_NOT_VERIFIED',
        label: 'Email Not Verified',
    },
    {
        value: 'MOBILE_VERIFIED',
        label: 'Mobile Phone Verified',
    },
    {
        value: 'MOBILE_NOT_VERIFIED',
        label: 'Mobile Phone Not Verified',
    },
];

export const BONUS_BLOCKED_OPTIONS = [
    {
        value: 'ALL',
        label: 'All',
    },
    {
        value: 'BLOCKED',
        label: 'Blocked',
    },
    {
        value: 'UNBLOCKED',
        label: 'Unblocked',
    },
];

export const OPERATING_SYSTEM_OPTIONS = [
    {
        value: 'IOS',
        label: 'IOS',
    },
    {
        value: 'ANDROID',
        label: 'Android',
    },
    {
        value: 'LINUX',
        label: 'Linux',
    },
    {
        value: 'WINDOWS',
        label: 'Windows',
    },
    {
        value: 'MAC_OS',
        label: 'MacOS',
    },
];

export const STAKE_SOURCE_OPTIONS = [
    {
        value: 'FREE_BET',
        label: 'Free bet',
    },
    {
        value: 'CASH',
        label: 'Cash',
    },
];

export const SPORTS_PERFORMANCE_COLUMNS = {
    numberOfBets: {
        key: 'numberOfBets',
        label: '# of Bets',
    },
    totalTurnOver: {
        key: 'totalTurnOver',
        label: 'Turnover',
    },
    totalGgr: {
        key: 'totalGGR',
        label: 'GGR',
    },
    margin: {
        key: 'margin',
        label: 'Margin (%)',
    },
    ofCashOutBets: {
        key: 'ofCashoutBets',
        label: '#of Cashout Bets',
    },
    cashOutTurnover: {
        key: 'cashoutTurnover',
        label: 'Cashout Turnover',
    },
    cashOutAmount: {
        key: 'cashoutAmount',
        label: 'Cashout Amount',
    },
    cashOutGgr: {
        key: 'cashoutGGR',
        label: 'Cashout GGR',
    },
    cashOutMargin: {
        key: 'cashOutMargin',
        label: 'Cashout Margin',
    },
};

export const SPORTS_OPTIONS = [
    {
        label: 'New Customer',
        value: '1',
    },
    {
        label: 'Beginner',
        value: '2',
    },
    {
        label: 'VIP Customer',
        value: '3',
    },
    {
        label: 'Normal',
        value: '4',
    },
];

export const CONDITION_TYPES = {
    boolean: 'BOOLEAN',
    date: 'DATE',
    gender: 'GENDER',
    amount: 'AMOUNT',
    city: 'CITY',
};

export const SPORTS_PERFORMANCE_PLAYERS_COLUMNS = {
    customerId: {
        label: 'Customer ID',
        value: 'accountNumber',
    },
    GGR: {
        key: 'ggr',
        label: 'GGR',
    },
};

export const SPORTS_PERFORMANCE_LEAGUES_COLUMNS = {
    leagueName: {
        label: 'League Name',
        value: 'leagueName',
    },
    GGR: {
        key: 'ggr',
        label: 'GGR',
    },
};

export const SPORTS_PERFORMANCE_EVENTS_COLUMNS = {
    eventName: {
        label: 'Event Name',
        value: 'eventName',
    },
    GGR: {
        key: 'ggr',
        label: 'GGR',
    },
};

export const MONEY_TRANSACTIONS_OPERATION_GROUP_OPTIONS = [
    {
        label: 'Bet Deposits',
        value: 'BET_DEPOSITS',
    },
    {
        label: 'Bet Winnings',
        value: 'BET_WINNINGS',
    },
    {
        label: 'Deposits',
        value: 'DEPOSITS',
    },
    {
        label: 'Withdrawals',
        value: 'WITHDRAWALS',
    },
    {
        label: 'Bonuses',
        value: 'BONUSES',
    },
    {
        label: 'Manual Deposits',
        value: 'MANUAL_DEPOSITS',
    },
    {
        label: 'Manual Withdrawals',
        value: 'MANUAL_WITHDRAWALS',
    },
    {
        label: 'All Besides Dept With',
        value: 'ALL_BESIDES_DEPT_WITH',
    },
    {
        label: 'Deposit and Withdrawals',
        value: 'DEPOSIT_AND_WITHDRAWALS',
    },
    {
        label: 'Bet Correction ',
        value: 'BET_CORRECTION',
    },
    {
        label: 'Bonus Sport Wagering',
        value: 'SPORT_WAGERING_GIVEN',
    },
    {
        label: 'Sport Wagering Cancel',
        value: 'SPORT_WAGERING_CANCEL',
    },
    {
        label: 'Sport Wagering Spent',
        value: 'SPORT_WAGERING_SPENT',
    },
    {
        label: 'Sport Wagering Redeem',
        value: 'SPORT_WAGERING_REDEEM',
    },
    {
        label: 'Free Bet Given',
        value: 'FREE_BET_GIVEN',
    },
    {
        label: 'Free Bet Cancel',
        value: 'FREE_BET_CANCEL',
    },
    {
        label: 'Free Bet Spent',
        value: 'FREE_BET_SPENT',
    },
    {
        label: 'Risk Free Bet Given',
        value: 'RISK_FREE_BET_GIVEN',
    },
    {
        label: 'Risk Free Bet Cancel',
        value: 'RISK_FREE_BET_CANCEL',
    },
    {
        label: 'Risk Free Bet Spent',
        value: 'RISK_FREE_BET_SPENT',
    },
    {
        label: 'Cash Out',
        value: 'CASH_OUT',
    },
];

export const MONEY_TRANSACTIONS_TABLE_COLUMNS = {
    dateTime: {
        key: 'dateTime',
        label: 'Date & Time',
    },
    transactionId: {
        key: 'transactionId',
        label: 'Transaction ID',
    },
    customerId: {
        key: 'customerId',
        label: 'Customer ID ',
    },
    fullName: {
        key: 'fullName',
        label: 'Full Name ',
    },
    ticketCode: {
        key: 'ticketCode',
        label: 'Ticket Code',
    },
    operationType: {
        key: 'operationType',
        label: 'Operation Type',
    },
    amount: {
        key: 'amount',
        label: 'Amount',
    },
    status: {
        key: 'status',
        label: 'Status',
    },
    currentStatus: {
        key: 'currentStatus',
        label: 'Current Status',
    },
    balance: {
        key: 'balance',
        label: 'Balance',
    },
    operationId: {
        key: 'operationId',
        label: 'Operation ID',
    },
    paymentType: {
        key: 'paymentType',
        label: 'Payment Type',
    },
    bonusBalance: {
        key: 'bonusBalance',
        label: 'Bonus Balance',
    },
    bonusType: {
        key: 'bonusType',
        label: 'Bonus Type',
    },
};

export const MONEY_TRANSACTIONS_BET_LINE_TABLE_COLUMNS = {
    eventId: {
        key: 'eventId',
        label: 'Event Id',
    },
    event: {
        key: 'event',
        label: 'Event',
    },
    status: {
        key: 'status',
        label: 'Status',
    },
    kickStartDate: {
        key: 'kickStartDate',
        label: 'Kick Start Date',
    },
    league: {
        key: 'league',
        label: 'League',
    },
    bettingScore: {
        key: 'bettingScore',
        label: 'Betting Score',
    },
    matchScore: {
        key: 'matchScore',
        label: 'Match Score',
    },
    outcomeName: {
        key: 'outcomeName',
        label: 'Outcome Name',
    },
    odds: {
        key: 'odds',
        label: 'Odds',
    },
    marketName: {
        key: 'marketName',
        label: 'Market Name',
    },
    live: {
        key: 'live',
        label: 'Live',
    },
    banco: {
        key: 'banco',
        label: 'Banco',
    },
    stakeAmount: {
        key: 'stakeAmount',
        label: 'Stake Amount',
    },
    settlementScore: {
        key: 'settlementScore',
        label: 'Settlement Score',
    },
    sportName: {
        key: 'sportName',
        label: 'Sport Name',
    },
    betLineId: {
        key: 'betLineId',
        label: 'Bet Line ID',
    },
    manuallySettled: {
        key: 'manuallySettled',
        label: 'Manually Settled',
    },
    settlementStatus: {
        key: 'settlementStatus',
        label: 'Settlement Status',
    },
    logs: {
        key: 'logs',
        label: 'Logs',
    },
};
export const MONEY_TRANSACTIONS_TICKET_TABLE_COLUMNS = {
    betId: {
        key: 'betId',
        label: 'Bet Id',
    },
    code: {
        key: 'code',
        label: 'Ticket Code',
    },
    ticketTypes: {
        key: 'ticketTypes',
        label: 'Bet Type',
    },
    systemValues: {
        key: 'systemValues',
        label: 'System Values',
    },
    issuedDate: {
        key: 'issuedDate',
        label: 'Issued Date',
    },
    settlementDate: {
        key: 'settlementDate',
        label: 'Settlement Date',
    },
    totalStakeAmount: {
        key: 'totalStakeAmount',
        label: 'Total Stake ',
    },
    totalBonusAmount: {
        key: 'totalBonusAmount',
        label: 'Total Bonus ',
    },
    totalWinAmount: {
        key: 'totalWinAmount',
        label: 'Total Win ',
    },
    totalPayAmount: {
        key: 'totalPayAmount',
        label: 'Total Pay ',
    },
    paidAt: {
        key: 'paidAt',
        label: 'Paid At ',
    },
    payoutAmount: {
        key: 'payoutAmount',
        label: 'Payout Amount ',
    },
    odds: {
        key: 'odds',
        label: 'Odds',
    },
    stakePerBet: {
        key: 'stakePerBet',
        label: 'Stake Per Bet',
    },
    winTax: {
        key: 'winTax',
        label: 'Win Tax',
    },
    paidBy: {
        key: 'paidBy',
        label: 'Paid By ',
    },
};

export const MONEY_TRANSACTIONS_PAYMENT_TABLE_COLUMNS = {
    creationDate: {
        key: 'creationDate',
        label: 'Creation Date',
    },
    transactionId: {
        key: 'transactionId',
        label: ' Transaction ID',
    },
    accountStatus: {
        key: 'accountStatus',
        label: 'Account Status',
    },
    amount: {
        key: 'amount',
        label: 'Amount',
    },
    customerId: {
        key: 'customerId',
        label: 'Customer ID',
    },
    paymentMethod: {
        key: 'paymentMethod',
        label: 'Payment Method',
    },
    paymentProvider: {
        key: 'paymentProvider',
        label: 'Payment Provider',
    },
    paymentStatus: {
        key: 'paymentStatus',
        label: 'Payment Status',
    },
    paymentType: {
        key: 'paymentType',
        label: 'Payment Type',
    },
    sportLevel: {
        key: 'sportLevel',
        label: 'Sport Level',
    },

    lastUpdateDate: {
        key: 'lastUpdateDate',
        label: 'Last Update Date',
    },
};

export const PAYMENT_METHODS_TABLE_COLUMNS = {
    id: {
        key: 'id',
        label: 'ID',
    },
    name: {
        key: 'name',
        label: 'Name',
    },
    status: {
        key: 'status',
        label: 'Status',
    },
    type: {
        key: 'type',
        label: 'Type',
    },
    platforms: {
        key: 'platforms',
        label: 'Platforms',
    },
};

export const MULTI_ACCOUNTS_OPTIONS = [
    {
        value: false,
        label: 'No',
    },
    {
        value: true,
        label: 'Yes',
    },
];

export const GENDER_OPTIONS = [
    {
        value: 'MALE',
        label: 'Male',
    },
    {
        value: 'FEMALE',
        label: 'Female',
    },
];

export const KYC_VERIFICATION_STATUS_OPTIONS = [
    {
        value: 1,
        label: 'Not Verified',
    },
    {
        value: 2,
        label: 'Pending',
    },
    {
        value: 3,
        label: 'Rejected',
    },
    {
        value: 4,
        label: 'Verified',
    },
];

export const DOCUMENT_STATUSES = [
    {
        value: 2,
        name: 'PENDING',
        label: 'Pending',
    },
    {
        value: 3,
        name: 'REJECTED',
        label: 'Rejected',
    },
    {
        value: 4,
        name: 'VERIFIED',
        label: 'Verified',
    },
];

export const PLAYER_STATUS_OPTIONS = [
    {
        value: 1,
        label: 'Active',
    },
    {
        value: 2,
        label: 'Inactive',
    },
    {
        value: 3,
        label: 'Deleted',
    },
    {
        value: 4,
        label: 'Frozen',
    },
    {
        value: 5,
        label: 'Self-excluded',
    },
    {
        value: 6,
        label: 'Closed',
    },
];

export const COMPETITION_TYPE_OPTIONS = [
    {
        value: 'PRE_MATCH',
        label: 'Pre-match',
    },
    {
        value: 'LIVE',
        label: 'Live',
    },
];

export const EVENT_TYPES_OPTIONS = [
    {
        value: 'REGULAR',
        label: 'Regular',
    },
    {
        value: 'OUTRIGHT',
        label: 'Outright',
    },
];

export const GENDER_TYPES = {
    1: 'Male',
    2: 'Female',
};

export const DOCUMENT_TYPES = [
    {
        label: 'Personal ID',
        value: 'PERSONAL_ID',
    },
    {
        label: 'Driving License',
        value: 'DRIVING_LICENCE',
    },
    {
        label: 'Passport',
        value: 'PASSPORT',
    },
];

export const PLAYER_NOTE_PAGE_TYPES = {
    note: 'note',
    risk: 'risk',
};

export const RESPONSIBLE_GAMING_DEPOSIT_LIMITS_COLUMNS = {
    limitType: {
        key: 'limitType',
        label: 'Limit Type',
    },
    limit: {
        key: 'limit',
        label: 'Limit',
    },
    used: {
        key: 'used',
        label: 'Used',
    },
    remaining: {
        key: 'remaining',
        label: 'Remaining',
    },
};

export const DEPOSIT_LIMIT_TYPES = [
    {
        label: 'Daily',
        value: 'DAILY',
    },
    {
        label: 'Weekly',
        value: 'WEEKLY',
    },
    {
        label: 'Monthly',
        value: 'MONTHLY',
    },
];

export const BONUS_CREATION_MONEY_TO_WAGER_OPTIONS = {
    realAndBonus: {
        value: 'REAL_AND_BONUS',
        name: 'Real and Bonus ',
    },
    realMoneyOnly: {
        value: 'REAL_MONEY_ONLY',
        name: 'Real Money Only ',
    },
    bonusMoneyOnly: {
        value: 'BONUS_MONEY_ONLY',
        name: 'Bonus Money Only ',
    },
};

export const EXPIRATION_TIME_TYPES = {
    daysTillExpiration: 'DAYS_TILL_EXPIRATION',
    exactDateAndTime: 'EXACT_DATE_AND_TIME',
    dayOfTheWeek: 'DAY_OF_THE_WEEK',
};

export const EXPIRATION_TIME_TYPES_OPTIONS = [
    {
        value: EXPIRATION_TIME_TYPES.daysTillExpiration,
        label: 'Days Till Expiration ',
    },
    {
        value: EXPIRATION_TIME_TYPES.exactDateAndTime,
        label: 'Exact Date and Time',
    },
    {
        value: EXPIRATION_TIME_TYPES.dayOfTheWeek,
        label: 'Day of the Week',
    },
];

export const BONUS_AMOUNT_TYPES = {
    fixed: 'FIXED',
    percentOfBetsAmount: 'PERCENT_OF_BET_AMOUNT',
    percentOfDeposit: 'PERCENT_OF_DEPOSIT',
    percentOfQualifiedBets: 'PERCENT_OF_QUALIFIED_BETS',
};

export const QUALIFYING_WAGERING_REQUIREMENT = {
    onDepositAmount: 'ON_DEPOSIT_AMOUNT',
    fixedTurnoverAmount: 'FIXED_TURNOVER_AMOUNT',
};

export const QUALIFYING_FULFILMENT_DETAILS = {
    activatesFreeBetImmediately: 'ACTIVATES_FREE_BET_IMMEDIATELY',
    activatesFreeBetEndOfExpirationTime: 'ACTIVATES_FREE_BET_END_OF_THE_EXPIRATION_TIME_AT',
};

export const QUALIFYING_BET_STATUSES = {
    all: 'ALL',
    open: 'OPEN',
    won: 'WON',
    lost: 'LOST',
    cancelled: 'CANCELLED',
    cashOut: 'CASH_OUT',
    draw: 'DRAW',
};

export const sportConditionInitialFormListValue = {
    [FILTER_PARAMS.clientType]: null,
    [FILTER_PARAMS.numberOfBetsRequired]: null,
    [FILTER_PARAMS.contribution]: null,
    [FILTER_PARAMS.competitionType]: null,
    [FILTER_PARAMS.availableAnySportEnabled]: false,
    [FILTER_PARAMS.qualifyingBetStatus]: null,
    [FILTER_PARAMS.sportParams]: {
        [FILTER_PARAMS.sportId]: { values: [], conditionType: 'IN' },
        [FILTER_PARAMS.categoryId]: { values: [], conditionType: 'IN' },
        [FILTER_PARAMS.leagueId]: { values: [], conditionType: 'IN' },
        [FILTER_PARAMS.eventId]: { values: [], conditionType: 'IN' },
        [FILTER_PARAMS.marketId]: { values: [], conditionType: 'IN' },
        [FILTER_PARAMS.outcomeId]: { values: [], conditionType: 'IN' },
    },
};

export const SPORT_CONDITIONS_STEPS_KEYS = {
    betBoostUseConditions: 'betBoostUseConditions',
    freeBetQualifyingConditions: 'freeBetQualifyingConditions',
    freeBetUseConditions: 'freeBetUseConditions',
    betsConditions: 'betsConditions',
};

export const PROMOTION_ISSUING_TYPE_OPTIONS = [
    {
        value: 'AUTOMATIC',
        label: 'Automatic',
    },
    // {
    //     value: 'MANUAL',
    //     label: 'Manual',
    // },
    {
        value: 'SCHEDULED',
        label: 'Scheduled',
    },
];

export const TRIGGER_TYPE_OPTIONS = [
    {
        value: 'DEPOSIT',
        label: 'Deposit',
        type: ['AUTOMATIC', 'MANUAL'],
    },
    {
        value: 'SIGNUP',
        label: 'Signup',
        type: ['AUTOMATIC', 'MANUAL'],
    },
    {
        value: 'LOGIN',
        label: 'Login',
        type: ['AUTOMATIC'],
    },
    {
        value: 'BET_PLACEMENT',
        label: 'Bet Placement',
        type: ['AUTOMATIC'],
    },
    {
        value: 'BET_SETTLEMENT',
        label: 'Bet Settlement',
        type: ['AUTOMATIC'],
    },
    {
        value: 'OPT_IN',
        label: 'Opt-in',
        type: ['MANUAL'],
    },
];

export const BONUS_TYPE = [
    { value: 'SPORT_WAGERING', label: 'Sports Wagering' },
    { value: 'FREE_BET', label: 'Free Bet/Risk-Free Bet' },
    { value: 'BET_BOOST', label: 'Bet Boost' },
];
export const PLAYER_UPLOAD_TYPES = [
    { value: 'INCLUDE_PLAYERS', label: 'Include Players' },
    { value: 'EXCLUDE_PLAYERS', label: 'Exclude Players' },
];

export const FILE_UPLOAD_TYPES = [
    { value: 'MERGE', label: ' Merge Lists' },
    { value: 'REPLACE', label: ' Replace Lists' },
];

export const FREE_BETS_OPTIONS = [
    {
        value: 'FREE_BET_EXCLUDED',
        label: 'Free Bets Excluded',
    },
    {
        value: 'FREE_BET_INCLUDED',
        label: 'Free Bets Included ',
    },
    {
        value: 'FREE_BET_ONLY',
        label: 'Free Bets Only  ',
    },
];

export const WEEKDAYS = [
    {
        value: 1,
        label: 'Monday',
    },
    {
        value: 2,
        label: 'Tuesday',
    },
    {
        value: 3,
        label: 'Wednesday',
    },
    {
        value: 4,
        label: 'Thursday',
    },
    {
        value: 5,
        label: 'Friday',
    },
    {
        value: 6,
        label: 'Saturday',
    },
    {
        value: 7,
        label: 'Sunday',
    },
];

export const SEGMENTATION_PERIODS = [
    {
        value: 'DAILY',
        label: 'Daily',
    },
    {
        value: 'WEEKLY',
        label: 'Weekly',
    },
    {
        value: 'MONTHLY',
        label: 'Monthly',
    },
    {
        value: 'YEARLY',
        label: 'Yearly',
    },
];

export const CALCULATION_BASED_OPTIONS = [
    {
        value: 'TURNOVER',
        label: 'Turnover',
    },
    {
        value: 'NGR',
        label: 'NGR',
    },
    {
        value: 'GGR',
        label: 'GGR',
    },
    {
        value: 'DEPOSIT',
        label: 'Deposit',
    },
];

export const PROMOTION_CRITERIAS = [
    {
        criteria: 'AVG_DEPOSIT',
        valueType: 'OPERATION_TYPE',
        values: null,
    },
    {
        criteria: 'BONUS_GIVEN',
        valueType: 'OPERATION_TYPE',
        values: null,
    },
    {
        criteria: 'BONUS_SPENT',
        valueType: 'OPERATION_TYPE',
        values: null,
    },
    {
        criteria: 'CURRENT_PENDING_WITHDRAWAL_AMOUNT',
        valueType: 'OPERATION_TYPE',
        values: null,
    },
    {
        criteria: 'CUSTOMER_LEVEL',
        valueType: 'MEMBERSHIP_TYPE',
        values: [
            'NEW_PUNTER',
            'VIP',
            'MOVEMENT_BETTOR',
            'DELAYED_PUNTER',
            'ARBITRAGER',
            'PROFESSIONAL_PUNTER',
            'VALUE_BETTOR',
            'OPERATORS_POLICY',
            'AGENT',
            'TEST_USER',
            'LIMITED_PUNTER',
        ],
    },
    {
        criteria: 'DATE_OF_BIRTH',
        valueType: 'PERIOD_FILTER_TYPE',
        values: null,
    },
    {
        criteria: 'DAYS_SINCE_LAST_DEPOSIT',
        valueType: 'OPERATION_TYPE',
        values: null,
    },
    {
        criteria: 'DAYS_SINCE_LAST_GIVEN_BONUS',
        valueType: 'OPERATION_TYPE',
        values: null,
    },
    {
        criteria: 'DAYS_SINCE_LAST_LOGIN',
        valueType: 'OPERATION_TYPE',
        values: null,
    },
    {
        criteria: 'DAYS_SINCE_LAST_WITHDRAWAL',
        valueType: 'OPERATION_TYPE',
        values: null,
    },
    {
        criteria: 'DAYS_SINCE_LAST_REGISTRATION',
        valueType: 'OPERATION_TYPE',
        values: null,
    },
    {
        criteria: 'FIRST_BET_DATE_ON_SPORTS',
        valueType: 'OPERATION_TYPE',
        values: null,
    },
    {
        criteria: 'FIRST_DEPOSIT_DATE',
        valueType: 'OPERATION_TYPE',
        values: null,
    },
    {
        criteria: 'GENDER',
        valueType: 'MEMBERSHIP_TYPE',
        values: ['MALE', 'FEMALE'],
    },
    {
        criteria: 'KYC_VERIFICATION_STATUS',
        valueType: 'MEMBERSHIP_TYPE',
        values: ['NOT_VERIFIED', 'PENDING', 'REJECTED', 'VERIFIED'],
    },
    {
        criteria: 'LAST_BET_DATE',
        valueType: 'PERIOD_FILTER_TYPE',
        values: null,
    },
    {
        criteria: 'LAST_DEPOSIT_AMOUNT',
        valueType: 'OPERATION_TYPE',
        values: null,
    },
    {
        criteria: 'LAST_DEPOSIT_DATE',
        valueType: 'PERIOD_FILTER_TYPE',
        values: null,
    },
    {
        criteria: 'LAST_SPORTS_BET_DATE',
        valueType: 'PERIOD_FILTER_TYPE',
        values: null,
    },
    {
        criteria: 'LAST_WITHDRAWAL_AMOUNT',
        valueType: 'OPERATION_TYPE',
        values: null,
    },
    {
        criteria: 'LAST_WITHDRAWAL_DATE',
        valueType: 'PERIOD_FILTER_TYPE',
        values: null,
    },
    {
        criteria: 'NET_CASH',
        valueType: 'OPERATION_TYPE',
        values: null,
    },
    {
        criteria: 'NUMBER_OF_SPORT_DEPOSITS',
        valueType: 'OPERATION_TYPE',
        values: null,
    },
    {
        criteria: 'REGISTRATION_DATE',
        valueType: 'PERIOD_FILTER_TYPE',
        values: null,
    },
    {
        criteria: 'REGISTRATION_DEVICE',
        valueType: 'MEMBERSHIP_TYPE',
        values: ['WEB', 'MOBILE', 'APP', 'TABLET'],
    },
    {
        criteria: 'RISK_SCORE',
        valueType: 'OPERATION_TYPE',
        values: null,
    },
    {
        criteria: 'SPORT_GGR',
        valueType: 'OPERATION_TYPE',
        values: null,
    },
    {
        criteria: 'SPORT_NGR',
        valueType: 'OPERATION_TYPE',
        values: null,
    },
    {
        criteria: 'SPORTS_BONUS_BALANCE',
        valueType: 'OPERATION_TYPE',
        values: null,
    },
    {
        criteria: 'SPORTS_REAL_BALANCE',
        valueType: 'OPERATION_TYPE',
        values: null,
    },
    {
        criteria: 'SPORTS_TURNOVER',
        valueType: 'OPERATION_TYPE',
        values: null,
    },
    {
        criteria: 'TOTAL_BALANCES',
        valueType: 'OPERATION_TYPE',
        values: null,
    },
    {
        criteria: 'TOTAL_NUMBER_OF_PENDING_WITHDRAWALS',
        valueType: 'OPERATION_TYPE',
        values: null,
    },
    {
        criteria: 'TOTAL_NUMBER_OF_WITHDRAWALS',
        valueType: 'OPERATION_TYPE',
        values: null,
    },
    {
        criteria: 'TOTAL_WITHDRAWAL_AMOUNT',
        valueType: 'OPERATION_TYPE',
        values: null,
    },
    {
        criteria: 'VIP_LEVEL',
        valueType: 'MEMBERSHIP_TYPE',
        values: ['NORM', 'HIGH_VALUE_SPORTS', 'HYBRID', 'VIP'],
    },
];

export const BONUS_TYPES = {
    sportWagering: 'sportWagering',
    betBoost: 'betBoost',
    freeBet: 'freeBet',
    freeBetUseConditions: 'freeBetUseConditions',
    promotion: 'promotion',
};

const SINGLE_BET_PARAMETER_TYPES = {
    stakePerBet: { title: 'Stake Per Bet', key: 'STAKE_PER_BET' },
    singleBetOdds: { title: 'Single Bet Odds', key: 'BET_ODDS' },
    singleBetReturns: { title: 'Single Bet Returns', key: 'BET_RETURNS' },
    singleBetAmount: { title: 'Single Bet Amount', key: 'BET_AMOUNT' },
};

const COMBO_BET_PARAMETER_TYPES = {
    stakePerBet: { title: 'Stake Per Bet', key: 'STAKE_PER_BET' },
    comboBetOdds: { title: 'Combo Bet Odds', key: 'BET_ODDS' },
    comboBetNumberOfSelections: {
        title: 'Combo Bet Number of Selections',
        key: 'BET_NUMBER_OF_SELECTION',
    },
    comboBetSelectionOdds: {
        title: 'Combo Bet Selection Odds',
        key: 'BET_SELECTION_ODDS',
    },
    comboBetReturns: { title: 'Combo Bet Returns', key: 'BET_RETURNS' },
    comboBetAmount: { title: 'Combo Bet Amount', key: 'BET_AMOUNT' },
};

export const BONUS_BET_PARAMETERS = {
    sportWagering: {
        SINGLE: [SINGLE_BET_PARAMETER_TYPES.stakePerBet, SINGLE_BET_PARAMETER_TYPES.singleBetOdds],
        COMBO: [
            COMBO_BET_PARAMETER_TYPES.stakePerBet,
            COMBO_BET_PARAMETER_TYPES.comboBetOdds,
            COMBO_BET_PARAMETER_TYPES.comboBetNumberOfSelections,
            COMBO_BET_PARAMETER_TYPES.comboBetSelectionOdds,
        ],
    },
    betBoost: {
        SINGLE: [
            SINGLE_BET_PARAMETER_TYPES.singleBetAmount,
            SINGLE_BET_PARAMETER_TYPES.singleBetOdds,
            SINGLE_BET_PARAMETER_TYPES.singleBetReturns,
        ],
        COMBO: [
            COMBO_BET_PARAMETER_TYPES.comboBetAmount,
            COMBO_BET_PARAMETER_TYPES.comboBetOdds,
            COMBO_BET_PARAMETER_TYPES.comboBetReturns,
            COMBO_BET_PARAMETER_TYPES.comboBetNumberOfSelections,
            COMBO_BET_PARAMETER_TYPES.comboBetSelectionOdds,
        ],
    },
    freeBet: {
        SINGLE: [SINGLE_BET_PARAMETER_TYPES.stakePerBet, SINGLE_BET_PARAMETER_TYPES.singleBetOdds],
        COMBO: [
            COMBO_BET_PARAMETER_TYPES.stakePerBet,
            COMBO_BET_PARAMETER_TYPES.comboBetOdds,
            COMBO_BET_PARAMETER_TYPES.comboBetNumberOfSelections,
            COMBO_BET_PARAMETER_TYPES.comboBetSelectionOdds,
        ],
    },
    freeBetUseConditions: {
        SINGLE: [SINGLE_BET_PARAMETER_TYPES.singleBetOdds],
        COMBO: [
            COMBO_BET_PARAMETER_TYPES.stakePerBet,
            COMBO_BET_PARAMETER_TYPES.comboBetOdds,
            COMBO_BET_PARAMETER_TYPES.comboBetNumberOfSelections,
            COMBO_BET_PARAMETER_TYPES.comboBetSelectionOdds,
        ],
    },
    promotion: {
        SINGLE: [SINGLE_BET_PARAMETER_TYPES.stakePerBet, SINGLE_BET_PARAMETER_TYPES.singleBetOdds],
        COMBO: [
            COMBO_BET_PARAMETER_TYPES.stakePerBet,
            COMBO_BET_PARAMETER_TYPES.comboBetOdds,
            COMBO_BET_PARAMETER_TYPES.comboBetNumberOfSelections,
            COMBO_BET_PARAMETER_TYPES.comboBetSelectionOdds,
        ],
    },
};

export const BONUSES_TABLE_COLUMNS = {
    id: {
        key: 'id',
        label: 'ID',
    },
    bonusType: {
        key: 'bonusType',
        label: 'Bonus Type',
    },
    bonusName: {
        key: 'bonusName',
        label: 'Bonus Name',
    },
    calculationType: {
        key: 'calculationType',
        label: 'Calculation Type',
    },
    percentage: {
        key: 'percentage',
        label: 'Percentage',
    },
    maxFixedOdds: {
        key: 'maxFixedOdds',
        label: 'Max Fixed Odds',
    },
    maxFixedAmount: {
        key: 'maxFixedAmount',
        label: 'Max Fixed Amount',
    },
    status: {
        key: 'status',
        label: 'Status',
    },
};

export const QUALIFYING_BET_STATUS_OPTIONS = {
    sportWagering: [
        {
            value: QUALIFYING_BET_STATUSES.won,
            label: 'Won',
        },
        {
            value: QUALIFYING_BET_STATUSES.lost,
            label: 'Lost',
        },
    ],
    freeBetQualifyingConditions: [
        {
            value: QUALIFYING_BET_STATUSES.all,
            label: 'All',
        },
        {
            value: QUALIFYING_BET_STATUSES.won,
            label: 'Won',
        },
        {
            value: QUALIFYING_BET_STATUSES.lost,
            label: 'Lost',
        },
    ],
    betsConditions: [
        {
            value: QUALIFYING_BET_STATUSES.all,
            label: 'All',
        },
        {
            value: QUALIFYING_BET_STATUSES.open,
            label: 'Open',
        },
        {
            value: QUALIFYING_BET_STATUSES.won,
            label: 'Won',
        },
        {
            value: QUALIFYING_BET_STATUSES.lost,
            label: 'Lost',
        },
        {
            value: QUALIFYING_BET_STATUSES.cancelled,
            label: 'Cancelled',
        },
        {
            value: QUALIFYING_BET_STATUSES.cashOut,
            label: 'Cash Out',
        },
        {
            value: QUALIFYING_BET_STATUSES.draw,
            label: 'Draw',
        },
    ],
};

export const STOP_REPEAT_OPTIONS = {
    on: {
        value: 'ON',
        label: 'On',
    },
    after: {
        value: 'AFTER',
        label: 'After',
    },
    never: {
        value: 'NEVER',
        label: 'Never',
    },
};

export const PERIOD_TYPES = [
    {
        value: 'TODAY',
        label: 'Today',
    },
    {
        value: 'YESTERDAY',
        label: 'Yesterday',
    },
    {
        value: 'CURRENT_WEEK',
        label: 'Current week',
    },
    {
        value: 'CURRENT_MONTH',
        label: 'Current month',
    },
    {
        value: 'LAST_3_DAYS',
        label: 'Last 3 days',
    },
    {
        value: 'LAST_7_DAYS',
        label: 'Last 7 days',
    },
    {
        value: 'LAST_14_DAYS',
        label: 'Last 14 days',
    },
    {
        value: 'LAST_30_DAYS',
        label: 'Last 30 days',
    },
    {
        value: 'LAST_WEEK',
        label: 'Last week',
    },
    {
        value: 'LAST_MONTH',
        label: 'Last month',
    },
    {
        value: 'BETWEEN_7_AND_14_DAYS_AGO',
        label: 'Between 7 and 14 days ago',
    },
    {
        value: 'BETWEEN_14_AND_30_DAYS_AGO',
        label: 'Between 14 and 30 days ago',
    },
    {
        value: 'BETWEEN_30_AND_60_DAYS_AGO',
        label: 'Between 30 and 60 days ago',
    },
    {
        value: 'DATE_RANGE',
        label: 'Range',
    },
    {
        value: 'BEFORE',
        label: 'Before',
    },
    {
        value: 'AFTER',
        label: 'After',
    },
];

export const CHANNELS_BET_ACCEPTANCE = [
    {
        id: 'retail',
        name: 'Retail',
        value: true,
    },
    {
        id: 'online',
        name: 'Online',
        value: false,
    },
];

export const INCLUSIVE_CONDITION_OPTIONS = [
    {
        value: 'IN',
        label: 'In',
    },
    {
        value: 'NOT_IN',
        label: 'Not in',
    },
];

export const BONUS_DATE_OPTIONS = [
    {
        value: 'CREATION_DATE',
        label: 'Bonus Creation Date',
    },
    {
        value: 'UPDATE_DATE',
        label: 'Bonus Update Date',
    },
    {
        value: 'GIVEN_DATE',
        label: 'Bonus Given Date',
    },
];

export const BONUS_STATUS_OPTIONS = [
    {
        value: 'OPEN',
        label: 'Opened',
    },
    {
        value: 'CLOSED',
        label: 'Closed',
    },
    {
        value: 'CANCELED',
        label: 'Canceled',
    },
    {
        value: 'WITHDRAW_DISABLED',
        label: 'Withdraw Disabled',
    },
    {
        value: 'EXPIRED',
        label: 'Expired',
    },
    {
        value: 'PLACING',
        label: 'Placing',
    },
    {
        value: 'PLACED',
        label: 'Placed',
    },
];

export const ISSUING_METHOD_OPTIONS = [
    {
        value: 'MANUALLY',
        label: 'Manually',
    },
    {
        value: 'CASHIER_PROMOTION',
        label: 'Cashier Promotion',
    },
    {
        value: 'CODE_INPUT_DEPOSIT',
        label: 'Code Input Deposit',
    },
    {
        value: 'CODE_INPUT_SIGN_UP',
        label: 'Code Input Signup',
    },
    {
        value: 'CODE_INPUT_OPT_IN',
        label: 'Code Input Opt-in',
    },
    {
        value: 'AUTOMATIC_PROMOTION_DEPOSIT',
        label: 'Automatic Promotion Deposit',
    },
    {
        value: 'AUTOMATIC_PROMOTION_SIGNUP',
        label: 'Automatic Promotion Signup',
    },
    {
        value: 'AUTOMATIC_PROMOTION_LOGIN',
        label: 'Automatic Promotion Login',
    },
    {
        value: 'AUTOMATIC_PROMOTION_BET_SETTLEMENT',
        label: 'Automatic Promotion Bet Settlement',
    },
    {
        value: 'AUTOMATIC_PROMOTION_BET_PLACEMENT',
        label: 'Automatic Promotion Bet Placement',
    },
    {
        value: 'SCHEDULED_PROMOTION',
        label: 'Scheduled Promotion',
    },
];

export const FINANCIAL_PARAMETERS_OPTIONS = [
    {
        value: 'BONUS_AMOUNT',
        label: 'Bonus amount',
    },
    {
        value: 'BONUS_WAGERING_PERCENTAGE',
        label: 'Bonus wagering percentage',
    },
    {
        value: 'WITHDRAWABLE_BONUS',
        label: 'Withdrawable bonus',
    },
];

export const BONUS_ENGINE_MONITOR_OPTIONS = [
    {
        value: 'PROMOTION_OFFERS',
        label: 'Promotions Offers',
    },
    {
        value: 'BONUS_WAGERING',
        label: 'Bonus Wagering',
    },
];

export const REASON_TYPE = [
    {
        value: 'SUCCESSFULL',
        label: 'SuccessfulL',
    },
    {
        value: 'FAILED',
        label: 'Failed',
    },
    {
        value: 'BET_UPDATE',
        label: 'Bet Update',
    },
    {
        value: 'BET_REMOVAL',
        label: 'Bet Removal',
    },
    {
        value: 'PROMOTION_UPDATE',
        label: 'Promotion Update',
    },
];

export const BONUS_ENGINE_MONITOR_COLUMNS = {
    resultTime: {
        key: 'resultTime',
        label: 'Result Time',
    },
    eventDate: {
        key: 'eventDate',
        label: 'Event Date',
    },
    eventType: {
        key: 'eventType',
        label: 'Event Type',
    },
    eventOrBetId: {
        key: 'eventOrBetId',
        label: 'Event ID/Ticket Code',
    },
    customerId: {
        key: 'accountNumber',
        label: ' Customer ID',
    },
    promotionOrBonusId: {
        key: 'promotionOrBonusId',
        label: 'Promotion/Bonus ID',
    },
    reasonType: {
        key: 'reasonType',
        label: 'Reason Type',
    },
    reason: {
        key: 'reason',
        label: 'Reason',
    },
    additionalDetails: {
        key: 'additionalDetails',
        label: 'Additional Details',
    },
    bonusName: {
        key: 'bonusName',
        label: 'Bonus Name',
    },
    bonusType: {
        key: 'bonusType',
        label: 'Bonus Type',
    },
};

export const BONUS_WAGERING_REPORT_COLUMNS = {
    accountNumber: {
        key: 'accountNumber',
        label: 'Customer ID',
    },
    betByBonus: {
        key: 'betByBonus',
        label: 'Bet By Bonus',
    },
    betId: {
        key: 'betId',
        label: 'Ticket Code',
    },
    betType: {
        key: 'betType',
        label: 'Bet Type',
    },
    betPlacedAt: {
        key: 'betPlacedAt',
        label: 'Bet Placement Date',
    },
    betSettledAt: {
        key: 'betSettledAt',
        label: 'Bet Settlement Date',
    },
    userBonusId: {
        key: 'userBonusId',
        label: 'Player Bonus ID',
    },
    bonusName: {
        key: 'bonusName',
        label: 'Bonus Name',
    },
    bonusStatus: {
        key: 'bonusStatus',
        label: 'Bonus Status',
    },
    bonusCondition: {
        key: 'bonusCondition',
        label: 'Bonus Condition',
    },
    wageredAmount: {
        key: 'wageredAmount',
        label: 'Wagered Amount',
    },
    stake: {
        key: 'stake',
        label: 'Stake',
    },
    ticketStatus: {
        key: 'ticketStatus',
        label: 'Ticket Status',
    },
};

export const GRAND_MASS_UPDATE_ACTION_TYPES = [
    { value: 1, label: 'Give Bonus' },
    // { value: 2, label: 'Cancel Bonus' },
];

export const UPLOAD_TYPES = [
    { value: 1, label: 'CSV' },
    { value: 2, label: 'Segment' },
];

export const INLUSION_EXCLUSION_TYPES: { value: InclusionExclusionType; label: string }[] = [
    {
        value: 'INCLUDE',
        label: 'Include',
    },
    {
        value: 'EXCLUDE',
        label: 'Exclude',
    },
];

export const OFFER_LIMIT_TYPES = [
    {
        label: 'Daily',
        placeholder: 'Maximum daily offers',
        value: 'DAILY',
        inputName: FILTER_PARAMS.maxDailyOffers,
    },
    {
        label: 'Weekly',
        placeholder: 'Maximum weekly offers',
        value: 'WEEKLY',
        inputName: FILTER_PARAMS.maxWeeklyOffers,
    },
    {
        label: 'Monthly',
        placeholder: 'Maximum monthly offers',
        value: 'MONTHLY',
        inputName: FILTER_PARAMS.maxMonthlyOffers,
    },
    {
        label: 'Total',
        placeholder: 'Total',
        value: 'TOTAL',
        inputName: FILTER_PARAMS.totalOffers,
    },
];

export const GRAND_MASS_BONUSES_COLUMNS = {
    accountNumber: {
        key: 'accountNumber',
        label: 'Account Number',
    },
    amount: {
        key: 'amount',
        label: 'Amount',
    },
    wageringRequirement: {
        key: 'wageringRequirement',
        label: 'Wagering Requirement',
    },
    bonusBlocked: {
        key: 'bonusBlocked',
        label: 'Bonus Blocked',
    },

    action: {
        key: 'action',
        label: 'Action',
    },
};

export const dateFieldNames = [
    FILTER_PARAMS.playerSearch.accountRelated.registrationTime.base,
    FILTER_PARAMS.playerSearch.payments.firstDepositDate.base,
    FILTER_PARAMS.playerSearch.bonuses.lastBonusGiven.base,
    FILTER_PARAMS.playerSearch.payments.lastDepositDate.base,
    FILTER_PARAMS.playerSearch.bonuses.lastFreeBetGiven.base,
    FILTER_PARAMS.playerSearch.gaming.lastSportsPlayed.base,
    FILTER_PARAMS.playerSearch.responsibleGaming.selfExclusionStart.base,
    FILTER_PARAMS.playerSearch.responsibleGaming.selfExclusionEnd.base,
    FILTER_PARAMS.playerSearch.accountRelated.lastDocUploaded.base,
    FILTER_PARAMS.playerSearch.personalDetails.dateOfBirthTime,
    FILTER_PARAMS.playerSearch.tracking.lastLoginDate.base,
];

export const operationInputFieldNames = [
    FILTER_PARAMS.playerSearch.payments.firstDepositAmount.base,
    FILTER_PARAMS.playerSearch.payments.lastDepositAmount.base,
    FILTER_PARAMS.playerSearch.payments.singleMinDepositAmount.base,
    FILTER_PARAMS.playerSearch.payments.singleMaxDepositAmount.base,
    FILTER_PARAMS.playerSearch.payments.totalDepositAmount.base,
    FILTER_PARAMS.playerSearch.payments.averageDepositAmount.base,
    FILTER_PARAMS.playerSearch.payments.depositCount.base,
    FILTER_PARAMS.playerSearch.gaming.sportsBalance.base,
    FILTER_PARAMS.playerSearch.gaming.turnover.base,
    FILTER_PARAMS.playerSearch.gaming.ggr.base,
    FILTER_PARAMS.playerSearch.bonuses.lastBonusAmount.base,
    FILTER_PARAMS.playerSearch.bonuses.bonusGiven.base,
    FILTER_PARAMS.playerSearch.bonuses.bonusSpent.base,
];

export const BANNER_USER_HIDE_OPTIONS = [
    { value: 'INCLUDE_USERS', label: 'Include Users' },
    { value: 'EXCLUDE_USERS', label: 'Exclude Users' },
];

export const PROMOTION_TYPES = {
    register: {
        id: 1,
        name: 'Register',
    },
    deposit: {
        id: 2,
        name: 'Deposit',
    },
    externalLink: {
        id: 3,
        name: 'External Link',
    },
    info: {
        id: 4,
        name: 'Info',
    },
    featuredLink: {
        id: 5,
        name: 'Featured Link',
    },
};

export const EVENT_TYPE_OPTIONS = [
    {
        value: 'DEPOSIT',
        label: 'Deposit',
    },
    {
        value: 'LOGIN',
        label: 'Login',
    },
    {
        value: 'SIGNUP',
        label: 'SignUp',
    },
    {
        value: 'BET_PLACEMENT',
        label: 'Bet Placement',
    },
    {
        value: 'BET_SETTLEMENT',
        label: 'Bet Settlement',
    },
    {
        value: 'BONUS_COMPLETION',
        label: 'Bonus Completion',
    },
    {
        value: 'OPT_IN',
        label: 'Opt-in',
    },
    {
        value: 'API',
        label: 'Api',
    },
    {
        value: 'SCHEDULED',
        label: 'Scheduled',
    },
];

export const STATUS_COLORS = {
    1: {
        name: 'active',
        color: 'green',
    },
    2: {
        name: 'inactive',
        color: 'default',
    },
    3: {
        name: 'deleted',
        color: 'red',
    },
};

export const TICKET_BONUS_USAGE = [
    {
        label: 'With bonus',
        value: 'WITH_BONUS',
    },
    {
        label: 'Without bonus',
        value: 'WITHOUT_BONUS',
    },
];

export const BONUS_OFFERS_STATUS = [
    {
        value: 'ACCEPTED',
        label: 'Accepted',
    },
    {
        value: 'FAILED',
        label: 'Failed',
    },
];

export const PLAYER_BONUS_OFFERS_COLUMNS = {
    bonusAmount: {
        key: 'bonusAmount',
        label: 'Bonus Amount',
    },
    bonusGiven: {
        key: 'bonusGiven',
        label: 'Bonus Given',
    },
    bonusName: {
        key: 'bonusName',
        label: 'Bonus Name',
    },
    customerActionTime: {
        key: 'customerActionTime',
        label: 'Customer Action Time',
    },
    eventOrBetId: {
        key: 'eventOrBetId',
        label: 'Event ID/Ticket Code',
    },
    offerCreationTime: {
        key: 'offerCreationTime',
        label: 'Offer Creation Time',
    },
    promotionId: {
        key: 'promotionId',
        label: 'Promotion ID',
    },
    promotionName: {
        key: 'promotionName',
        label: 'Promotion Name',
    },
    status: {
        key: 'status',
        label: 'Status',
    },
    trigger: {
        key: 'trigger',
        label: 'Trigger',
    },
    userBonusId: {
        key: 'userBonusId',
        label: 'Player Bonus ID',
    },
};

export const BONUS_TYPE_OPTIONS = [
    {
        label: 'Sport Wagering',
        value: 'SPORT_WAGERING',
    },
    {
        label: 'Bet Boost',
        value: 'BET_BOOST',
    },
    {
        label: 'Free Bet',
        value: 'FREE_BET',
    },
    {
        label: 'Risk Free Bet',
        value: 'RISK_FREE_BET',
    },
];

export const PLAYER_BONUS_REGULAR_COLUMNS = {
    bonusGgr: {
        key: 'bonusGgr',
        label: 'Bonus Ggr',
    },
    bonusSpentOverGgrPct: {
        key: 'bonusSpentOverGgrPct',
        label: 'Bonus Spent Over Ggr Percentage',
    },
    cancelledAmount: {
        key: 'cancelledAmount',
        label: 'Cancelled Amount',
    },
    givenAmount: {
        key: 'givenAmount',
        label: 'Given Amount',
    },
    spentAmount: {
        key: 'spentAmount',
        label: 'Spent Amount',
    },
    redeemedAmount: {
        key: 'redeemedAmount',
        label: 'Redeemed Amount',
    },
    redeemedCount: {
        key: 'redeemedCount',
        label: 'Redeemed Count',
    },
};

export const PROMOTION_STATUS_OPTIONS = [
    {
        value: 'ACTIVE',
        label: 'Active',
    },
    {
        value: 'INACTIVE',
        label: 'Inactive',
    },
    {
        value: 'DELETED',
        label: 'Deleted',
    },
];

export const PROMOTION_BONUS_OFFERS_COLUMNS = {
    reward: {
        key: 'reward',
        label: 'Reward',
    },
    createdOffers: {
        key: 'createdOffers',
        label: 'Created Offers',
    },
    accepted: {
        key: 'accepted',
        label: 'Accepted',
    },
    declined: {
        key: 'declined',
        label: 'Declined',
    },
    expiredCanceled: {
        key: 'expiredCanceled',
        label: 'Expired/Canceled',
    },
    failed: {
        key: 'failed',
        label: 'Failed',
    },
    waiting: {
        key: 'waiting',
        label: 'Waiting',
    },
};

export const DATE_TYPES = [
    {
        value: 'REGISTRATION_TIME',
        label: 'Registration',
    },
    {
        value: 'DEPOSIT_TIME',
        label: 'Deposit',
    },
];

export const AUDIT_TRAIL_REPORT_COLUMNS = {
    timestamp: {
        key: 'timestamp',
        label: 'Action Date & Time',
    },
    username: {
        key: 'username',
        label: 'Username',
    },
    clientIP: {
        key: 'clientIP',
        label: 'Client IP',
    },
    requestContent: {
        key: 'requestContent',
        label: 'Request Content',
    },
    requestMethod: {
        key: 'requestMethod',
        label: 'Request Method',
    },
    requestURI: {
        key: 'requestURI',
        label: 'Request URI',
    },
    operationDescription: {
        key: 'operationDescription',
        label: 'Operation Description',
    },
};

export const TICKET_STATUS_OPTIONS = [
    {
        value: 1,
        label: 'INITIALIZED',
    },
    {
        value: 2,
        label: 'OPEN',
    },
    {
        value: 3,
        label: 'CLOSED',
    },
    {
        value: 4,
        label: 'CANCELED',
    },
    {
        value: 5,
        label: 'WON',
    },
    {
        value: 6,
        label: 'LOST',
    },
    {
        value: 7,
        label: 'REFUNDED',
    },
    {
        value: 8,
        label: 'VOID',
    },
    {
        value: 9,
        label: 'CASH_OUT',
    },
];

export const MONEY_TRANSACTIONS_BONUS_TABLE_COLUMNS = {
    bonusId: {
        key: 'bonusId',
        label: 'Bonus ID',
    },
    bonusName: {
        key: 'bonusName',
        label: 'Bonus Name',
    },
    givenDate: {
        key: 'givenDate',
        label: 'Given Date',
    },
    givenAmount: {
        key: 'givenAmount',
        label: 'Given Amount',
    },
    depositTransferAmount: {
        key: 'depositTransferAmount',
        label: 'Deposit/Transfer Amount',
    },
    promotionId: {
        key: 'promotionId',
        label: 'Promotion ID',
    },
    bonusStatus: {
        key: 'bonusStatus',
        label: 'Bonus Status',
    },
    promotionName: {
        key: 'promotionName',
        label: 'Promotion Name',
    },
};

export const DOCUMENT_SIDE_TYPES = {
    PERSONAL_ID: ['FRONT', 'BACK', 'SELFIE'],
    DRIVING_LICENCE: ['FRONT', 'SELFIE'],
    PASSPORT: ['FRONT', 'SELFIE'],
};

export const segmentConditionOptions = ['DAYS', 'TURNOVER', 'DEPOSIT', 'MARGIN', 'BET_COUNT'];

export const operationTypeOptions = ['EQUAL', 'NOT_EQUAL', 'GREATER', 'GREATER_EQUAL', 'LESS', 'LESS_EQUAL', 'BETWEEN'];

export const APPLICATION_TYPES = [
    { value: 'ANDROID', label: 'Android' },
    { value: 'IOS', label: 'iOS' },
    { value: 'WEB', label: 'Web' },
];

export const UPDATE_VERSION_TABLE_COLUMNS = {
    applicationType: {
        key: 'applicationType',
        label: 'Application Type',
    },
    createdAt: {
        key: 'createdAt',
        label: 'Created At',
    },
    forceUpdate: {
        key: 'forceUpdate',
        label: 'Update Type',
    },
    notificationCount: {
        key: 'notificationCount',
        label: 'Notification Count',
    },
    notificationInterval: {
        key: 'notificationInterval',
        label: 'Notification Interval',
    },
    status: {
        key: 'status',
        label: 'Status',
    },
    updatedAt: {
        key: 'updatedAt',
        label: 'Updated At',
    },
    version: {
        key: 'version',
        label: 'Version',
    },
};
export const GRAND_MASS_BONUSES_TABLE_COLUMNS = {
    createdAt: {
        key: 'createdAt',
        label: 'Created At',
    },
    cancelledAt: {
        key: 'cancelledAt',
        label: 'Cancelled At',
    },
    cancelledBy: {
        key: 'cancelledBy',
        label: 'Cancelled By ',
    },
    givenBy: {
        key: 'givenBy',
        label: 'Given By',
    },
    name: {
        key: 'name',
        label: 'Name',
    },
    totalBonusAmount: {
        key: 'totalBonusAmount',
        label: 'Total Bonus Amount',
    },
    totalBonusCount: {
        key: 'totalBonusCount',
        label: 'Total Bonus Count',
    },
    totalCancelledBonusAmount: {
        key: 'totalCancelledBonusAmount',
        label: 'Total Cancelled Bonus Amount',
    },
    totalCancelledBonusCount: {
        key: 'totalCancelledBonusCount',
        label: 'Total Cancelled Bonus Count',
    },
    action: {
        key: 'action',
        label: 'Action',
    },
};

export const ODD_RANGES_OPTIONS = [
    {
        value: 'Custom',
        label: 'Custom',
    },
    {
        value: 'All',
        label: 'All',
    },
];

export const CASHOUT_BLOCK_TYPES = {
    TICKET: 'TICKET',
    LEAGUE_MARKET_COMBINATION: 'LEAGUE_MARKET_COMBINATION',
    EVENT: 'EVENT',
};
